var $jXom6$reactjsxruntime = require("react/jsx-runtime");
var $jXom6$react = require("react");
var $jXom6$styledcomponents = require("styled-components");
var $jXom6$usehooksts = require("usehooks-ts");
var $jXom6$simplebarreact = require("simplebar-react");
require("simplebar/dist/simplebar.min.css");
var $jXom6$smoothscrollintoviewifneeded = require("smooth-scroll-into-view-if-needed");
var $jXom6$rcslider = require("rc-slider");
require("rc-slider/assets/index.css");
var $jXom6$datepickerreacthooks = require("@datepicker-react/hooks");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "Accordion", function () { return $906ee81c6c1db5eb$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CustomAccordion", function () { return $81cddd8d5c3e47e4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Button", function () { return $2987665db72ba3c1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Card", function () { return $48087ec110ef8615$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Box", function () { return $476168fcb44518cc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DisplayLarge", function () { return $ec746cba4029e202$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DisplayIcon", function () { return $e0180679e35f2273$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DisplaySmall", function () { return $d98b0fa15808b520$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DropdownSelect", function () { return $69ead81f7adc490a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DropdownCascader", function () { return $d8e895830981b43b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Field", function () { return $2677d04b7028c72d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Searchbar", function () { return $aa6f4c7dc0f5685c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Textarea", function () { return $870ba58bccab6eec$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Slider", function () { return $409b8f5f63cd4acf$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "FileUploader", function () { return $eab617fde0d2a814$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Datepicker", function () { return $1d445195934320ed$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Radio", function () { return $86e1d79a67710eda$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Checkbox", function () { return $b679852ecf8e9c02$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Switch", function () { return $34871b0f15f7c161$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "AlertMessage", function () { return $d963730b715e990c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PushMessage", function () { return $cadd1c9c3bca1fc9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CompactPagination", function () { return $831351fb15d68ad0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "StandardPagination", function () { return $60c375d8d52bb6d6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Tabs", function () { return $35a1a5ac66949050$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Breadcrumb", function () { return $a6857e6cae2f9c5f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LinearProgress", function () { return $8688d42e9f1d381a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CircularProgress", function () { return $e09296aea30ed10d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Steps", function () { return $250cfcb8116ed97e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Timeline", function () { return $c3e303edb7751c77$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CustomTimeline", function () { return $a3f868921843a442$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Tag", function () { return $4c05722f1abfb34c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Tooltip", function () { return $4ceeceac8d19d80b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ScrollbarContainer", function () { return $b252c20c2dedb54c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Copiable", function () { return $f9cf7fe05b87a0bc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "lightTheme", function () { return $18386f08588a981e$export$f30cb9bc4f736419; });
$parcel$export(module.exports, "darkTheme", function () { return $18386f08588a981e$export$3e936a8db52a10a0; });
$parcel$export(module.exports, "veaTheme", function () { return $18386f08588a981e$export$a183395ddd946500; });









function $e1b614a35dc83093$export$683480f191c0e3ea(element, callback) {
    (0, $jXom6$react.useLayoutEffect)(()=>{
        if (!element) return;
        const observer = new ResizeObserver((entries)=>{
            callback(element, entries[0]);
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        callback,
        element
    ]);
}
var $e1b614a35dc83093$export$2e2bcd8739ae039 = $e1b614a35dc83093$export$683480f191c0e3ea;


function $2592152d06a7ba66$export$2b86bedf890eab8() {
    // Mutable values like 'ref.current' aren't valid dependencies
    // because mutating them doesn't re-render the component.
    // Instead, we use a state as a ref to be reactive.
    const [ref, setRef] = (0, $jXom6$react.useState)(null);
    const [size, setSize] = (0, $jXom6$react.useState)({
        width: 0,
        height: 0
    });
    // Prevent too many rendering using useCallback
    const handleSize = (0, $jXom6$react.useCallback)(()=>{
        setSize({
            width: ref?.offsetWidth || 0,
            height: ref?.offsetHeight || 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    (0, $jXom6$usehooksts.useEventListener)("resize", handleSize);
    (0, $jXom6$usehooksts.useIsomorphicLayoutEffect)(()=>{
        handleSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    (0, $e1b614a35dc83093$export$683480f191c0e3ea)(ref, handleSize);
    return [
        setRef,
        size
    ];
}
var $2592152d06a7ba66$export$2e2bcd8739ae039 = $2592152d06a7ba66$export$2b86bedf890eab8;




const $f15a4f5132e5ea52$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            clipRule: "evenodd",
            d: "M8.697 0H7.302c-.124 0-.186.06-.186.178v6.977H.186c-.124 0-.186.06-.186.178v1.334c0 .118.062.177.186.177h6.93v6.978c0 .119.062.178.186.178h1.395c.124 0 .186-.06.186-.178V8.844h6.931c.124 0 .186-.059.186-.177V7.333c0-.118-.062-.178-.186-.178h-6.93V.178C8.883.059 8.82 0 8.696 0Z"
        })
    });
var $f15a4f5132e5ea52$export$2e2bcd8739ae039 = $f15a4f5132e5ea52$var$SvgPlus;




const $ed272acf889bf255$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M15.826.333H.174A.174.174 0 0 0 0 .507v1.305c0 .095.078.174.174.174h15.652A.174.174 0 0 0 16 1.812V.507a.174.174 0 0 0-.174-.174Z"
        })
    });
var $ed272acf889bf255$export$2e2bcd8739ae039 = $ed272acf889bf255$var$SvgMinus;



const $49a276e58256b44f$export$44eafa1b177a8b30 = (styleFn)=>(0, $jXom6$styledcomponents.css)([
        "@media (max-width:900px){",
        "}"
    ], styleFn());
const $49a276e58256b44f$export$448e4850cad7c7b0 = (0, $jXom6$styledcomponents.css)([
    "font-size:24px;font-weight:600;line-height:33px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $49a276e58256b44f$export$a943aa9a0fca3f0b = (0, $jXom6$styledcomponents.css)([
    "font-size:16px;font-weight:600;line-height:22px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $49a276e58256b44f$export$ffb5f4729a158638 = (0, $jXom6$styledcomponents.css)([
    "font-size:16px;font-weight:400;line-height:22px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $49a276e58256b44f$export$3c17b0e969a90510 = (0, $jXom6$styledcomponents.css)([
    "font-size:14px;font-weight:400;line-height:19px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsSecondaryText);
const $49a276e58256b44f$export$b4adb3f464574dcf = (0, $jXom6$styledcomponents.css)([
    "opacity:1;"
]);
const $49a276e58256b44f$export$7ed1367e7fa1ad68 = (0, $jXom6$styledcomponents.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $49a276e58256b44f$export$463b44d9bf3628be = (0, $jXom6$styledcomponents.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $49a276e58256b44f$export$2ba01fb71ed41cb6 = (0, $jXom6$styledcomponents.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;text-transform:none;-webkit-appearance:button;:hover:enabled{cursor:pointer;}"
]);
const $49a276e58256b44f$export$b7e3ae3d7c15e42e = (0, $jXom6$styledcomponents.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;"
]);
const $49a276e58256b44f$export$b9d336f245a516e8 = (0, $jXom6$styledcomponents.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $49a276e58256b44f$export$2e6c959c16ff56b8 = (0, $jXom6$styledcomponents.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;text-transform:none;"
]);
const $49a276e58256b44f$export$a3574df893ffa88d = (0, $jXom6$styledcomponents.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $49a276e58256b44f$export$ed32643c9618a26 = (0, $jXom6$styledcomponents.css)([
    "box-sizing:border-box;*,*:before,*:after{box-sizing:border-box;}"
]);


const $33bd37d24f01bb71$var$StyledDiv = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "accordion-item__StyledDiv",
    componentId: "sc-17yp2l-0"
})([
    "margin:8px 0px;.accordion-button{",
    " width:100%;background:",
    ";border-radius:3px;padding:11.5px 32px;display:flex;justify-content:space-between;align-items:center;.accordion-svg{",
    " height:16px;width:16px;fill:",
    ";}}"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), ({ theme: theme })=>theme.klerosUIComponentsPrimaryPurple, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $33bd37d24f01bb71$var$Collapsible = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "accordion-item__Collapsible",
    componentId: "sc-17yp2l-1"
})([
    "height:",
    "px;overflow:",
    ";transition:height ease ",
    ";"
], (props)=>props.expanded ? props.totalHeight.toString() : "0", (props)=>props.expanded ? "visible" : "hidden", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $33bd37d24f01bb71$var$Body = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "accordion-item__Body",
    componentId: "sc-17yp2l-2"
})([
    "padding:32px;"
]);
const $33bd37d24f01bb71$var$AccordionItem = ({ title: title, body: body, index: index, expanded: expanded, setExpanded: setExpanded })=>{
    const [ref, { height: height }] = (0, $2592152d06a7ba66$export$2b86bedf890eab8)();
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($33bd37d24f01bb71$var$StyledDiv, {
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)("button", {
                className: "accordion-button",
                onClick: ()=>setExpanded(expanded ? -1 : index),
                children: [
                    title,
                    expanded ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $ed272acf889bf255$export$2e2bcd8739ae039), {
                        className: "accordion-svg"
                    }) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $f15a4f5132e5ea52$export$2e2bcd8739ae039), {
                        className: "accordion-svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($33bd37d24f01bb71$var$Collapsible, {
                expanded: expanded,
                totalHeight: height,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($33bd37d24f01bb71$var$Body, {
                    ref: ref,
                    children: [
                        " ",
                        body,
                        " "
                    ]
                })
            })
        ]
    });
};
var $33bd37d24f01bb71$export$2e2bcd8739ae039 = $33bd37d24f01bb71$var$AccordionItem;



const $906ee81c6c1db5eb$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "accordion__Wrapper",
    componentId: "sc-7o1u6g-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $906ee81c6c1db5eb$var$AccordionTitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).p.withConfig({
    displayName: "accordion__AccordionTitle",
    componentId: "sc-7o1u6g-1"
})([
    "",
    " width:fit-content;font-weight:600;text-align:center;color:",
    ";"
], (0, $49a276e58256b44f$export$ffb5f4729a158638), ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $906ee81c6c1db5eb$var$DefaultTitle = ({ item: item })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)((0, $jXom6$reactjsxruntime.Fragment), {
        children: [
            item.icon ?? (item.Icon && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(item.Icon, {})),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($906ee81c6c1db5eb$var$AccordionTitle, {
                children: item.title
            })
        ]
    });
const $906ee81c6c1db5eb$var$Accordion = ({ items: items, defaultExpanded: defaultExpanded, ...props })=>{
    const [expanded, setExpanded] = (0, $jXom6$react.useState)(defaultExpanded ?? -1);
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($906ee81c6c1db5eb$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $33bd37d24f01bb71$export$2e2bcd8739ae039), {
                index: index,
                title: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($906ee81c6c1db5eb$var$DefaultTitle, {
                    item: item
                }),
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $906ee81c6c1db5eb$export$2e2bcd8739ae039 = $906ee81c6c1db5eb$var$Accordion;







const $81cddd8d5c3e47e4$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-dc5dy3-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $81cddd8d5c3e47e4$var$CustomAccordion = ({ items: items, ...props })=>{
    const [expanded, setExpanded] = (0, $jXom6$react.useState)(-1);
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($81cddd8d5c3e47e4$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $33bd37d24f01bb71$export$2e2bcd8739ae039), {
                index: index,
                title: item.title,
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $81cddd8d5c3e47e4$export$2e2bcd8739ae039 = $81cddd8d5c3e47e4$var$CustomAccordion;







const $85dbc8aeed51bed3$var$breathing = (0, $jXom6$styledcomponents.keyframes)([
    "0%{transform:scale(1);}50%{transform:scale(1.3);}100%{transform:scale(1);}"
]);
const $85dbc8aeed51bed3$var$BaseButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "base__BaseButton",
    componentId: "sc-15fqe1k-0"
})([
    "",
    " ",
    " position:relative;width:fit-content;height:fit-content;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:",
    ";border-radius:3px;border:none;transition:background ease ",
    ";.button-text{",
    " ",
    " font-weight:600;text-align:center;white-space:pre;}.button-svg{",
    " ",
    " height:16px;width:16px;margin-right:8px;}.button-loading{position:absolute;height:22px;fill:",
    ";animation:",
    " 2s ease-out infinite normal;}"
], (0, $49a276e58256b44f$export$ed32643c9618a26), (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), (props)=>{
    if (props.small) return props.variant === "secondary" ? "5px 23px" : "6px 24px";
    return props.variant === "secondary" ? "10.5px 31px" : "11.5px 32px";
}, (props)=>props.theme.klerosUIComponentsTransitionSpeed, (0, $49a276e58256b44f$export$ffb5f4729a158638), ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", ({ theme: theme })=>theme.klerosUIComponentsStroke, $85dbc8aeed51bed3$var$breathing);
var $85dbc8aeed51bed3$export$2e2bcd8739ae039 = $85dbc8aeed51bed3$var$BaseButton;


const $64030e1eefd54f6b$var$PrimaryButton = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $85dbc8aeed51bed3$export$2e2bcd8739ae039)).withConfig({
    displayName: "primary__PrimaryButton",
    componentId: "sc-1cfrthg-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsSecondaryBlue);
var $64030e1eefd54f6b$export$2e2bcd8739ae039 = $64030e1eefd54f6b$var$PrimaryButton;




const $e015af9dc133eba5$var$SecondaryButton = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $85dbc8aeed51bed3$export$2e2bcd8739ae039)).withConfig({
    displayName: "secondary__SecondaryButton",
    componentId: "sc-urt0vi-0"
})([
    "background:",
    ";border:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? `1px solid ${props.theme.klerosUIComponentsStroke}` : `1px solid ${props.theme.klerosUIComponentsPrimaryBlue}`, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsMediumBlue);
var $e015af9dc133eba5$export$2e2bcd8739ae039 = $e015af9dc133eba5$var$SecondaryButton;




const $a028db5d769593a3$var$TertiaryButton = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $85dbc8aeed51bed3$export$2e2bcd8739ae039)).withConfig({
    displayName: "tertiary__TertiaryButton",
    componentId: "sc-jvmd2g-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.theme.klerosUIComponentsSecondaryPurple, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsPrimaryPurple);
var $a028db5d769593a3$export$2e2bcd8739ae039 = $a028db5d769593a3$var$TertiaryButton;




const $c65a9c2fdb9de77b$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 46 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "m14.545 3.992 21.06.94 8.526 18.92L32.1 41.143 10.929 39.79l-8.68-20.5L14.544 3.993Zm15.44 10.906-15.263 6.66L27.77 31.634l2.214-16.736Zm-1.768-3.337L16.02 6.316l-2.562 11.028 14.76-5.783Zm-3.091 22.608-13.257-9.454.321 12.81 12.936-3.356ZM42.013 23.81l-9.033-9.154-2.384 17.604 11.417-8.45Zm-13.78 12.418-11.18 2.918 13.148.84-1.967-3.758Zm12.015-8.264-9.786 7.28 1.944 3.796 7.842-11.076Zm-4.63-20.388-1.9 3.897 7.075 7.182-5.174-11.08ZM33.252 5.71l-12.424-.504 10.248 4.477 2.176-3.973ZM12.73 7.513 4.028 18.487l5.819 1.23L12.73 7.514ZM9.496 21.871 3.65 20.635l6.1 14.352-.254-13.116Z"
        })
    });
var $c65a9c2fdb9de77b$export$2e2bcd8739ae039 = $c65a9c2fdb9de77b$var$SvgKleros;


const $2987665db72ba3c1$var$Button = ({ text: text, variant: variant, Icon: Icon, icon: icon, onClick: onClick, isLoading: isLoading, ...props })=>{
    let ButtonType = (0, $64030e1eefd54f6b$export$2e2bcd8739ae039);
    if (variant === "secondary") ButtonType = (0, $e015af9dc133eba5$export$2e2bcd8739ae039);
    if (variant === "tertiary") ButtonType = (0, $a028db5d769593a3$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)(ButtonType, {
        variant: variant,
        onClick: onClick,
        isLoading: isLoading,
        ...props,
        children: [
            isLoading && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $c65a9c2fdb9de77b$export$2e2bcd8739ae039), {
                className: "button-loading"
            }),
            icon ?? (Icon && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(Icon, {
                className: "button-svg"
            })),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("p", {
                className: "button-text",
                children: text
            })
        ]
    });
};
var $2987665db72ba3c1$export$2e2bcd8739ae039 = $2987665db72ba3c1$var$Button;




const $48087ec110ef8615$var$Card = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "card__Card",
    componentId: "sc-1g2jfm3-0"
})([
    "",
    " background:",
    ";border:1px solid ",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:",
    ";width:328px;height:200px;transition:box-shadow ease ",
    ";",
    ""
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, ({ round: round })=>round ? "18px" : "3px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme, hover: hover })=>hover && `
      :hover {
        box-shadow: 0px 6px 9px ${theme.klerosUIComponentsHoveredShadow};
        cursor: pointer;
      }
  `);
var $48087ec110ef8615$export$2e2bcd8739ae039 = $48087ec110ef8615$var$Card;




const $476168fcb44518cc$var$Box = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "box__Box",
    componentId: "sc-1by74ub-0"
})([
    "",
    " background:",
    ";border-radius:18px;width:328px;height:200px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
var $476168fcb44518cc$export$2e2bcd8739ae039 = $476168fcb44518cc$var$Box;







const $ec746cba4029e202$var$StyledCard = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $48087ec110ef8615$export$2e2bcd8739ae039)).withConfig({
    displayName: "large__StyledCard",
    componentId: "sc-1f0y32e-0"
})([
    "position:relative;height:80px;width:288px;padding:16px;display:flex;flex-direction:column;align-items:start;justify-content:center;.display-icon{",
    " position:absolute;top:16px;right:16px;max-height:16px;max-width:16px;}.display-text{",
    "}.display-label{",
    "}"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), (0, $49a276e58256b44f$export$448e4850cad7c7b0), (0, $49a276e58256b44f$export$3c17b0e969a90510));
const $ec746cba4029e202$var$DisplayLarge = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($ec746cba4029e202$var$StyledCard, {
        ...props,
        children: [
            Icon && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(Icon, {
                className: "display-icon"
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("h1", {
                className: "display-text",
                children: text
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("small", {
                className: "display-label",
                children: label
            })
        ]
    });
var $ec746cba4029e202$export$2e2bcd8739ae039 = $ec746cba4029e202$var$DisplayLarge;







const $e0180679e35f2273$var$StyledCard = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $48087ec110ef8615$export$2e2bcd8739ae039)).withConfig({
    displayName: "icon__StyledCard",
    componentId: "sc-12ixf6j-0"
})([
    "height:80px;width:288px;padding:16px;display:flex;"
]);
const $e0180679e35f2273$var$Text = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "icon__Text",
    componentId: "sc-12ixf6j-1"
})([
    "",
    " height:100%;width:auto;margin-left:16px;flex-direction:column;align-items:start;justify-content:center;.display-text{",
    "}.display-label{",
    "}"
], (0, $49a276e58256b44f$export$ed32643c9618a26), (0, $49a276e58256b44f$export$448e4850cad7c7b0), (0, $49a276e58256b44f$export$3c17b0e969a90510));
const $e0180679e35f2273$var$IconCard = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $48087ec110ef8615$export$2e2bcd8739ae039)).withConfig({
    displayName: "icon__IconCard",
    componentId: "sc-12ixf6j-2"
})([
    "height:48px;width:48px;display:flex;justify-content:center;align-items:center;.display-icon{",
    " max-height:32px;max-width:32px;}"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68));
const $e0180679e35f2273$var$DisplayIcon = ({ text: text, Icon: Icon, label: label, ...props })=>{
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($e0180679e35f2273$var$StyledCard, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($e0180679e35f2273$var$IconCard, {
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(Icon, {
                    className: "display-icon"
                })
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($e0180679e35f2273$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("h1", {
                        className: "display-text",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("small", {
                        className: "display-label",
                        children: label
                    })
                ]
            })
        ]
    });
};
var $e0180679e35f2273$export$2e2bcd8739ae039 = $e0180679e35f2273$var$DisplayIcon;







const $d98b0fa15808b520$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "small__Wrapper",
    componentId: "sc-ismyqd-0"
})([
    "",
    " width:217px;display:flex;flex-direction:column;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $d98b0fa15808b520$var$StyledLabel = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "small__StyledLabel",
    componentId: "sc-ismyqd-1"
})([
    "",
    " color:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), (props)=>props.theme.klerosUIComponentsPrimaryText);
const $d98b0fa15808b520$var$StyledCard = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $48087ec110ef8615$export$2e2bcd8739ae039)).withConfig({
    displayName: "small__StyledCard",
    componentId: "sc-ismyqd-2"
})([
    "height:45px;width:100%;margin-top:16px;display:flex;align-items:center;padding:0px 16px;.display-icon{",
    " max-height:16px;max-width:16px;margin-right:8px;}"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68));
const $d98b0fa15808b520$var$StyledText = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h2.withConfig({
    displayName: "small__StyledText",
    componentId: "sc-ismyqd-3"
})([
    "",
    ""
], (0, $49a276e58256b44f$export$a943aa9a0fca3f0b));
const $d98b0fa15808b520$var$DisplaySmall = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d98b0fa15808b520$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d98b0fa15808b520$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d98b0fa15808b520$var$StyledCard, {
                children: [
                    Icon && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(Icon, {
                        className: "display-icon"
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d98b0fa15808b520$var$StyledText, {
                        children: text
                    })
                ]
            })
        ]
    });
var $d98b0fa15808b520$export$2e2bcd8739ae039 = $d98b0fa15808b520$var$DisplaySmall;






//! type
//eslint-disable-next-line @typescript-eslint/ban-types
function $bfcc265ae6655ec9$var$useFocusOutside(ref, callback) {
    (0, $jXom6$react.useEffect)(()=>{
        function handleEvent(event) {
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener("focusin", handleEvent);
        document.addEventListener("mousedown", handleEvent);
        return ()=>{
            document.removeEventListener("focusin", handleEvent);
            document.removeEventListener("mousedown", handleEvent);
        };
    }, [
        ref,
        callback
    ]);
}
var $bfcc265ae6655ec9$export$2e2bcd8739ae039 = $bfcc265ae6655ec9$var$useFocusOutside;









const $a4b0ebb54b8823c5$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 12 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M11.598.25H.402C.067.25-.121.605.087.847l5.598 6.49c.16.186.468.186.63 0l5.598-6.49c.208-.242.02-.597-.316-.597Z"
        })
    });
var $a4b0ebb54b8823c5$export$2e2bcd8739ae039 = $a4b0ebb54b8823c5$var$SvgArrow;



const $43d9fcbe58645246$var$Container = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "button__Container",
    componentId: "sc-wywpa8-0"
})([
    "",
    " ",
    " width:240px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:space-between;padding:0px 16px 0px 0px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26), (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43d9fcbe58645246$var$StyledArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))(({ ignoredIsOpen: ignoredIsOpen, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $a4b0ebb54b8823c5$export$2e2bcd8739ae039), {
        ...props
    })).withConfig({
    displayName: "button__StyledArrow",
    componentId: "sc-wywpa8-1"
})([
    "",
    " width:16px;height:16px;fill:",
    ";",
    " transition:transform ease ",
    ";"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ ignoredIsOpen: ignoredIsOpen })=>ignoredIsOpen && (0, $jXom6$styledcomponents.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43d9fcbe58645246$var$DropdownButton = ({ node: node, isOpen: isOpen, setIsOpen: setIsOpen, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($43d9fcbe58645246$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            node,
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($43d9fcbe58645246$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ...props
            })
        ]
    });
var $43d9fcbe58645246$export$2e2bcd8739ae039 = $43d9fcbe58645246$var$DropdownButton;







const $83ebe14398e57e2d$var$Container = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "simple-button__Container",
    componentId: "sc-rpqfxz-0"
})([
    "",
    " ",
    " background:none;display:flex;align-items:center;padding:0px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26), (0, $49a276e58256b44f$export$2ba01fb71ed41cb6));
const $83ebe14398e57e2d$var$StyledSmallText = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "simple-button__StyledSmallText",
    componentId: "sc-rpqfxz-1"
})([
    "",
    " font-weight:600;color:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $83ebe14398e57e2d$var$StyledBigText = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h1.withConfig({
    displayName: "simple-button__StyledBigText",
    componentId: "sc-rpqfxz-2"
})([
    "",
    " font-weight:600;color:",
    ";"
], (0, $49a276e58256b44f$export$448e4850cad7c7b0), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $83ebe14398e57e2d$var$StyledArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))(({ ignoredIsOpen: ignoredIsOpen, ignoredSmall: ignoredSmall, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $a4b0ebb54b8823c5$export$2e2bcd8739ae039), {
        ...props
    })).withConfig({
    displayName: "simple-button__StyledArrow",
    componentId: "sc-rpqfxz-3"
})([
    "",
    " width:",
    "px;height:",
    "px;fill:",
    ";",
    " transition:transform ease ",
    ";margin-left:8px;"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ ignoredSmall: small })=>small ? "8" : "16", ({ ignoredSmall: small })=>small ? "8" : "16", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ ignoredIsOpen: isOpen })=>isOpen && (0, $jXom6$styledcomponents.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $83ebe14398e57e2d$var$DropdownButton = ({ text: text, isOpen: isOpen, setIsOpen: setIsOpen, small: small, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($83ebe14398e57e2d$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            small ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($83ebe14398e57e2d$var$StyledSmallText, {
                children: text
            }) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($83ebe14398e57e2d$var$StyledBigText, {
                children: text
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($83ebe14398e57e2d$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ignoredSmall: small,
                ...props
            })
        ]
    });
var $83ebe14398e57e2d$export$2e2bcd8739ae039 = $83ebe14398e57e2d$var$DropdownButton;












const $b252c20c2dedb54c$var$CustomScrollbarContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, ($parcel$interopDefault($jXom6$simplebarreact)))).withConfig({
    displayName: "scrollbar__CustomScrollbarContainer",
    componentId: "sc-16x8nkv-0"
})([
    "",
    " .simplebar-scrollbar:before{background:",
    ";}.simplebar-scrollbar.simplebar-visible:before{opacity:1;}.simplebar-mask{background:",
    ";"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
var $b252c20c2dedb54c$export$2e2bcd8739ae039 = $b252c20c2dedb54c$var$CustomScrollbarContainer;



const $4fc41d5788d8f02e$var$ItemContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "base-item-container__ItemContainer",
    componentId: "sc-1h7f57o-0"
})([
    "",
    " flex:1;width:238px;height:auto;background:",
    ";padding:16px 0px;display:grid;grid-template-rows:repeat(auto-fill,minmax(0,45px));"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $4fc41d5788d8f02e$var$StyledScrollbarContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $b252c20c2dedb54c$export$2e2bcd8739ae039)).withConfig({
    displayName: "base-item-container__StyledScrollbarContainer",
    componentId: "sc-1h7f57o-1"
})([
    "width:238px;max-height:350px;"
]);
const $4fc41d5788d8f02e$var$ItemContainerWithScrollbar = ({ children: children, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($4fc41d5788d8f02e$var$StyledScrollbarContainer, {
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($4fc41d5788d8f02e$var$ItemContainer, {
            children: children
        })
    });
var $4fc41d5788d8f02e$export$2e2bcd8739ae039 = $4fc41d5788d8f02e$var$ItemContainerWithScrollbar;







const $66882cfb76c803d6$var$Dot = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "dot__Dot",
    componentId: "sc-1v9nycp-0"
})([
    "",
    " background:",
    ";border-radius:50%;width:8px;height:8px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ color: color })=>color);
var $66882cfb76c803d6$export$2e2bcd8739ae039 = $66882cfb76c803d6$var$Dot;



const $eff5a32ef289d478$var$Item = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "base-item__Item",
    componentId: "sc-1q4tyix-0"
})([
    "",
    " background:",
    ";padding:",
    ";display:flex;align-items:center;",
    " .item-icon{",
    " max-height:16px;max-width:16px;min-height:12px;min-width:12px;}"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsMediumBlue : theme.klerosUIComponentsWhiteBackground, ({ current: current })=>current ? "10.5px 16px 10.5px 13px" : "11.5px 16px 11.5px 13px", (props)=>!props.current && (0, $jXom6$styledcomponents.css)([
        ":hover{background:",
        ";cursor:pointer;}"
    ], props.theme.klerosUIComponentsMediumBlue), (0, $49a276e58256b44f$export$7ed1367e7fa1ad68));
const $eff5a32ef289d478$var$StyledText = (0, ($parcel$interopDefault($jXom6$styledcomponents))).p.withConfig({
    displayName: "base-item__StyledText",
    componentId: "sc-1q4tyix-1"
})([
    "",
    " font-size:16px;user-select:none;"
], (0, $49a276e58256b44f$export$ffb5f4729a158638));
const $eff5a32ef289d478$var$StyledDot = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $66882cfb76c803d6$export$2e2bcd8739ae039)).withConfig({
    displayName: "base-item__StyledDot",
    componentId: "sc-1q4tyix-2"
})([
    "margin-right:8px;"
]);
const $eff5a32ef289d478$var$BaseItem = ({ text: text, Icon: Icon, icon: icon, dot: dot, onClick: onClick, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($eff5a32ef289d478$var$Item, {
        onKeyPress: (e)=>onClick && e.key === "Enter" ? onClick() : undefined,
        onClick: onClick,
        ...props,
        children: [
            icon ?? (Icon && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(Icon, {
                className: "item-icon"
            })),
            dot && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($eff5a32ef289d478$var$StyledDot, {
                color: dot
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($eff5a32ef289d478$var$StyledText, {
                children: text
            })
        ]
    });
var $eff5a32ef289d478$export$2e2bcd8739ae039 = $eff5a32ef289d478$var$BaseItem;


const $bc9b74e06ed8f896$export$7c16ae7705e422c4 = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $eff5a32ef289d478$export$2e2bcd8739ae039)).withConfig({
    displayName: "item-container__StyledItem",
    componentId: "sc-b6y23n-0"
})([
    "border-left:3px solid ",
    ";",
    ""
], ({ theme: theme, selected: selected })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsWhiteBackground, ({ theme: theme, selected: selected, current: current })=>!current && (0, $jXom6$styledcomponents.css)([
        ":hover{border-left:3px solid ",
        ";}"
    ], selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsMediumBlue));
const $bc9b74e06ed8f896$var$ItemContainer = ({ items: items, selected: selected, onChange: onChange })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $4fc41d5788d8f02e$export$2e2bcd8739ae039), {
        children: items.map(({ text: text, Icon: Icon, icon: icon, dot: dot, value: value }, i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($bc9b74e06ed8f896$export$7c16ae7705e422c4, {
                tabIndex: 0,
                selected: value === selected,
                onClick: ()=>onChange(value),
                text: text,
                dot: dot,
                Icon: Icon,
                icon: icon
            }, i))
    });
var $bc9b74e06ed8f896$export$2e2bcd8739ae039 = $bc9b74e06ed8f896$var$ItemContainer;


const $2d381104713b6d5d$var$SelectButton = ({ item: item, simple: simple, small: small, isOpen: isOpen, setIsOpen: setIsOpen })=>simple ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $83ebe14398e57e2d$export$2e2bcd8739ae039), {
        text: item.text,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        small: small
    }) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $43d9fcbe58645246$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        node: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $bc9b74e06ed8f896$export$7c16ae7705e422c4), {
            current: true,
            ...item
        })
    });
var $2d381104713b6d5d$export$2e2bcd8739ae039 = $2d381104713b6d5d$var$SelectButton;






const $dad9719307029a16$var$Container = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "dropdown-container__Container",
    componentId: "sc-qkfxj5-0"
})([
    "",
    " ",
    ""
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme, isOpen: isOpen, alignRight: alignRight })=>(0, $jXom6$styledcomponents.css)([
        "position:absolute;",
        " z-index:100;visibility:",
        ";transform:scaleY(",
        ");transform-origin:top;transition-property:transform,visibility;transition-duration:",
        ";transition-timing-function:ease;height:auto;background:transparent;box-shadow:0px 2px 3px ",
        ";overflow:hidden;"
    ], alignRight ? "right: 0px;" : "", isOpen ? "visible" : "hidden", isOpen ? "1" : "0", theme.klerosUIComponentsTransitionSpeed, theme.klerosUIComponentsDefaultShadow));
const $dad9719307029a16$var$DropdownContainer = ({ children: children, isOpen: isOpen, alignRight: alignRight, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($dad9719307029a16$var$Container, {
        isOpen: isOpen,
        alignRight: alignRight,
        ...props,
        children: [
            " ",
            children,
            " "
        ]
    });
var $dad9719307029a16$export$2e2bcd8739ae039 = $dad9719307029a16$var$DropdownContainer;



const $69ead81f7adc490a$var$Container = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "select__Container",
    componentId: "sc-s4pei-0"
})([
    "position:relative;"
]);
const $69ead81f7adc490a$var$DropdownContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $dad9719307029a16$export$2e2bcd8739ae039)).withConfig({
    displayName: "select__DropdownContainer",
    componentId: "sc-s4pei-1"
})([
    "",
    ""
], ({ theme: theme })=>(0, $jXom6$styledcomponents.css)([
        "background:",
        ";border:1px solid ",
        ";border-radius:3px;"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsStroke));
const $69ead81f7adc490a$var$Select = ({ items: items, callback: callback, simpleButton: simpleButton, smallButton: smallButton, defaultValue: defaultValue, placeholder: placeholder, alignRight: alignRight, ...props })=>{
    const [isOpen, setIsOpen] = (0, $jXom6$react.useState)(false);
    const containerRef = (0, $jXom6$react.useRef)(null);
    (0, $bfcc265ae6655ec9$export$2e2bcd8739ae039)(containerRef, ()=>setIsOpen(false));
    const [selected, setSelected] = (0, $jXom6$react.useState)(defaultValue);
    const currentItem = items.find(({ value: value })=>value === selected);
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($69ead81f7adc490a$var$Container, {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2d381104713b6d5d$export$2e2bcd8739ae039), {
                item: currentItem ? currentItem : placeholder ? placeholder : {
                    text: ""
                },
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                simple: simpleButton,
                small: smallButton
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($69ead81f7adc490a$var$DropdownContainer, {
                isOpen: isOpen,
                alignRight: alignRight,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $bc9b74e06ed8f896$export$2e2bcd8739ae039), {
                    items: items,
                    selected: selected,
                    onChange: (value)=>{
                        new Promise((resolve)=>resolve(callback(value))).then(()=>{
                            setSelected(value);
                            setIsOpen(false);
                        }).catch((error)=>console.error(error));
                    }
                })
            })
        ]
    });
};
var $69ead81f7adc490a$export$2e2bcd8739ae039 = $69ead81f7adc490a$var$Select;
















const $be261e7e6de1aa96$var$SvgLightLeft = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        width: 7,
        height: 11,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M6.375 1.143V.107c0-.09-.103-.139-.173-.084L.165 4.739a.427.427 0 0 0 0 .673l6.037 4.716a.107.107 0 0 0 .173-.085V9.008a.217.217 0 0 0-.082-.168L1.472 5.075l4.821-3.765a.217.217 0 0 0 .082-.168Z"
        })
    });
var $be261e7e6de1aa96$export$2e2bcd8739ae039 = $be261e7e6de1aa96$var$SvgLightLeft;


const $2f29ff49e895ab7b$export$a1a71dc089009936 = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $eff5a32ef289d478$export$2e2bcd8739ae039)).withConfig({
    displayName: "item-container__StyledBaseItem",
    componentId: "sc-gth5to-0"
})([
    "position:relative;.item-icon{position:absolute;transform:rotate(180deg);right:16px;fill:",
    ";}"
], ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke);
const $2f29ff49e895ab7b$var$ItemContainer = ({ layer: layer, onChange: onChange, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $4fc41d5788d8f02e$export$2e2bcd8739ae039), {
        ...props,
        children: layer.items.map((item, i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2f29ff49e895ab7b$export$a1a71dc089009936, {
                tabIndex: 0,
                text: item.label,
                Icon: item.children && (0, $be261e7e6de1aa96$export$2e2bcd8739ae039),
                onClick: ()=>onChange(item),
                selected: item.value === layer.selected
            }, i))
    });
var $2f29ff49e895ab7b$export$2e2bcd8739ae039 = $2f29ff49e895ab7b$var$ItemContainer;








const $3b159669545f46c0$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "selector__Wrapper",
    componentId: "sc-1nl16fm-0"
})([
    "",
    " border-bottom-left-radius:3px;border-bottom-right-radius:3px;background:",
    ";padding:8px 16px;display:flex;",
    " justify-content:end;align-items:center;"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "justify-content:center;"
    ])));
const $3b159669545f46c0$var$Selector = ({ currentSelection: currentSelection, onSelect: onSelect, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($3b159669545f46c0$var$Wrapper, {
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2987665db72ba3c1$export$2e2bcd8739ae039), {
            onClick: ()=>onSelect(),
            text: currentSelection ? `Select\n${currentSelection}` : "No Selection",
            disabled: !currentSelection
        })
    });
var $3b159669545f46c0$export$2e2bcd8739ae039 = $3b159669545f46c0$var$Selector;


const $d8e895830981b43b$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $dad9719307029a16$export$2e2bcd8739ae039)).withConfig({
    displayName: "cascader__Wrapper",
    componentId: "sc-x4ug59-0"
})([
    "border:1px solid ",
    ";",
    " border-radius:3px;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "width:240px;"
    ])));
const $d8e895830981b43b$var$Container = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "cascader__Container",
    componentId: "sc-x4ug59-1"
})([
    "",
    ""
], ({ theme: theme, path: path, isOpen: isOpen })=>(0, $jXom6$styledcomponents.css)([
        "background:",
        ";border-bottom:1px solid ",
        ";border-radius:3px;display:grid;grid-template-columns:repeat(",
        ",238px) 0px;grid-template-rows:max-content;gap:1px;",
        ""
    ], isOpen ? theme.klerosUIComponentsStroke : theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, path.length, (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
            "overflow:auto;"
        ]))));
const $d8e895830981b43b$var$Cascader = ({ items: items, onSelect: onSelect, placeholder: placeholder, value: value, ...props })=>{
    const [path, setPath] = (0, $jXom6$react.useState)([
        {
            items: items
        }
    ]);
    const [current, setCurrent] = (0, $jXom6$react.useState)();
    const [selected, setSelected] = (0, $jXom6$react.useState)();
    const [isOpen, setIsOpen] = (0, $jXom6$react.useState)(false);
    const containerRef = (0, $jXom6$react.useRef)(null);
    const lastElementRef = (0, $jXom6$react.useRef)(null);
    (0, $bfcc265ae6655ec9$export$2e2bcd8739ae039)(containerRef, ()=>setIsOpen(false));
    (0, $jXom6$react.useEffect)(()=>{
        if (lastElementRef?.current && isOpen) (0, ($parcel$interopDefault($jXom6$smoothscrollintoviewifneeded)))(lastElementRef.current);
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        path
    ]);
    const label = (0, $jXom6$react.useMemo)(()=>value ? $d8e895830981b43b$var$findLabelByValue(items, value) : undefined, [
        items,
        value
    ]);
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)("div", {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $43d9fcbe58645246$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                node: selected ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2f29ff49e895ab7b$export$a1a71dc089009936), {
                    current: true,
                    text: selected.label
                }) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2f29ff49e895ab7b$export$a1a71dc089009936), {
                    current: true,
                    text: label ?? placeholder
                })
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d8e895830981b43b$var$Wrapper, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d8e895830981b43b$var$Container, {
                        path: path,
                        isOpen: isOpen,
                        children: [
                            path.map((layer, depth)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2f29ff49e895ab7b$export$2e2bcd8739ae039), {
                                    layer: layer,
                                    onChange: (item)=>{
                                        let newPath;
                                        if (depth < path.length) newPath = path.slice(0, depth + 1);
                                        else newPath = path;
                                        newPath[depth].selected = item.value;
                                        if (item.children) newPath.push({
                                            items: item.children
                                        });
                                        setPath(newPath);
                                        setCurrent(item);
                                    }
                                }, depth)),
                            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("div", {
                                ref: lastElementRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $3b159669545f46c0$export$2e2bcd8739ae039), {
                        onSelect: ()=>{
                            if (current) new Promise((resolve)=>resolve(onSelect(current.value))).then(()=>{
                                setSelected(current);
                                setIsOpen(false);
                            }).catch((error)=>console.error(error));
                        },
                        currentSelection: current?.label
                    })
                ]
            })
        ]
    });
};
/**
 * @param nodes the nodes
 * @param targetValue the value to search, can be string or number
 * @returns the label if the item is found, else returns undefined
 */ function $d8e895830981b43b$var$findLabelByValue(nodes, targetValue) {
    for (const node of nodes){
        if (node.value == targetValue) return node.label;
        if (node.children) {
            const result = $d8e895830981b43b$var$findLabelByValue(node.children, targetValue);
            if (result) return result;
        }
    }
    return undefined;
}
var $d8e895830981b43b$export$2e2bcd8739ae039 = $d8e895830981b43b$var$Cascader;







const $1fbc1df023618cf8$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 10.6a.567.567 0 0 1-.923 0L4.545 7.516a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z"
        })
    });
var $1fbc1df023618cf8$export$2e2bcd8739ae039 = $1fbc1df023618cf8$var$SvgSuccess;




const $773dfb225348757e$var$SvgWarning = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037 3.749a.857.857 0 1 1 1.211-1.212.857.857 0 0 1-1.211 1.212Zm1.034-2.606h-.857A.143.143 0 0 1 7.428 9V4.143c0-.079.065-.143.143-.143h.857c.079 0 .143.064.143.143V9a.143.143 0 0 1-.143.143Z"
        })
    });
var $773dfb225348757e$export$2e2bcd8739ae039 = $773dfb225348757e$var$SvgWarning;




const $1055d191a5da0897$var$SvgError = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.596-2.967c.079 0 .143.064.143.143 0 .034-.01.068-.032.093L8.741 8.037l2.32 2.766a.148.148 0 0 1 .033.092c0 .08-.064.143-.143.143l-1.178-.005L8 8.919l-1.773 2.116-1.18.005a.143.143 0 0 1-.11-.236L7.26 8.038 4.937 5.271a.149.149 0 0 1-.034-.093c0-.08.065-.143.143-.143l1.18.005L8 7.154l1.775-2.116 1.178-.005Z"
        })
    });
var $1055d191a5da0897$export$2e2bcd8739ae039 = $1055d191a5da0897$var$SvgError;




const $3b81fb62e49a97d5$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037-2.537a.857.857 0 1 1 1.212-1.212.857.857 0 0 1-1.212 1.212Zm.177 1.394h.857c.079 0 .143.064.143.143v4.857a.143.143 0 0 1-.143.143h-.857a.143.143 0 0 1-.143-.143V7c0-.079.065-.143.143-.143Z"
        })
    });
var $3b81fb62e49a97d5$export$2e2bcd8739ae039 = $3b81fb62e49a97d5$var$SvgInfo;



const $2677d04b7028c72d$export$ce7158e6888ab5d6 = (0, $jXom6$styledcomponents.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "warning") return theme.klerosUIComponentsWarning;
    if (variant === "error") return theme.klerosUIComponentsError;
    if (variant === "success") return theme.klerosUIComponentsSuccess;
    return theme.klerosUIComponentsSecondaryText;
});
const $2677d04b7028c72d$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "field__Wrapper",
    componentId: "sc-4pge1s-0"
})([
    "",
    " height:45px;width:278px;position:relative;color:red;.field-svg{",
    " height:16px;width:16px;position:absolute;top:14px;right:16px;}"
], (0, $49a276e58256b44f$export$ed32643c9618a26), (0, $49a276e58256b44f$export$7ed1367e7fa1ad68));
const $2677d04b7028c72d$var$StyledSuccessIcon = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $1fbc1df023618cf8$export$2e2bcd8739ae039)).withConfig({
    displayName: "field__StyledSuccessIcon",
    componentId: "sc-4pge1s-1"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsSuccess);
const $2677d04b7028c72d$var$StyledWarningIcon = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $773dfb225348757e$export$2e2bcd8739ae039)).withConfig({
    displayName: "field__StyledWarningIcon",
    componentId: "sc-4pge1s-2"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsWarning);
const $2677d04b7028c72d$var$StyledErrorIcon = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $1055d191a5da0897$export$2e2bcd8739ae039)).withConfig({
    displayName: "field__StyledErrorIcon",
    componentId: "sc-4pge1s-3"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsError);
const $2677d04b7028c72d$export$ceeb223748e25cf7 = (0, $jXom6$styledcomponents.css)([
    "height:100%;width:100%;background:",
    ";border:1px solid ",
    ";border-radius:3px;color:",
    ";:focus{outline:none;border:1px solid ",
    "40;box-shadow:0px 0px 6px ",
    ";border-radius:3px;}::placeholder{color:",
    ";opacity:0.5;}"
], (props)=>props.theme.klerosUIComponentsWhiteBackground, ({ variant: variant, theme: theme })=>variant ? $2677d04b7028c72d$export$ce7158e6888ab5d6 : theme.klerosUIComponentsStroke, (props)=>props.theme.klerosUIComponentsPrimaryText, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsSecondaryText);
const $2677d04b7028c72d$var$StyledInput = (0, ($parcel$interopDefault($jXom6$styledcomponents))).input.withConfig({
    displayName: "field__StyledInput",
    componentId: "sc-4pge1s-4"
})([
    "padding-top:14px;padding-bottom:14px;padding-left:16px;padding-right:",
    ";",
    ""
], ({ Icon: Icon, variant: variant })=>{
    if (Icon) return "56px";
    if (variant) return "44px";
    return "16px";
}, $2677d04b7028c72d$export$ceeb223748e25cf7);
const $2677d04b7028c72d$var$StyledSVG = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "field__StyledSVG",
    componentId: "sc-4pge1s-5"
})([
    ""
]);
const $2677d04b7028c72d$export$ca8581ef51d2f0a9 = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "field__StyledMessage",
    componentId: "sc-4pge1s-6"
})([
    "margin-top:6px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $2677d04b7028c72d$var$StyledSVG, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), $2677d04b7028c72d$export$ce7158e6888ab5d6);
const $2677d04b7028c72d$var$StyledSmall = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "field__StyledSmall",
    componentId: "sc-4pge1s-7"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), $2677d04b7028c72d$export$ce7158e6888ab5d6);
const $2677d04b7028c72d$var$IconContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "field__IconContainer",
    componentId: "sc-4pge1s-8"
})([
    "display:flex;width:44px;height:43px;position:absolute;top:1px;right:1px;align-items:center;justify-content:center;background:",
    ";border-left:1px solid ",
    ";"
], (props)=>props.theme.klerosUIComponentsLightBlue, (props)=>props.theme.klerosUIComponentsStroke);
const $2677d04b7028c72d$var$StyledIconSVG = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "field__StyledIconSVG",
    componentId: "sc-4pge1s-9"
})([
    "width:24px;height:24px;"
]);
const $2677d04b7028c72d$var$Field = ({ variant: variant, message: message, Icon: Icon, className: className, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($2677d04b7028c72d$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2677d04b7028c72d$var$StyledInput, {
                variant: variant,
                Icon: Icon,
                ...props
            }),
            variant === "success" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2677d04b7028c72d$var$StyledSuccessIcon, {
                className: "field-svg"
            }),
            variant === "warning" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2677d04b7028c72d$var$StyledWarningIcon, {
                className: "field-svg"
            }),
            variant === "error" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2677d04b7028c72d$var$StyledErrorIcon, {
                className: "field-svg"
            }),
            Icon && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2677d04b7028c72d$var$IconContainer, {
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2677d04b7028c72d$var$StyledIconSVG, {
                    as: Icon
                })
            }),
            message && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($2677d04b7028c72d$export$ca8581ef51d2f0a9, {
                variant: variant,
                children: [
                    variant === "info" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $3b81fb62e49a97d5$export$2e2bcd8739ae039), {
                        className: $2677d04b7028c72d$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2677d04b7028c72d$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$2677d04b7028c72d$var$Field.displayName = "Field";
var $2677d04b7028c72d$export$2e2bcd8739ae039 = $2677d04b7028c72d$var$Field;








const $619d93e693d921a0$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "m15.78 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51a6.468 6.468 0 0 0 1.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.885a.753.753 0 0 0 .003-1.062ZM6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4Z"
        })
    });
var $619d93e693d921a0$export$2e2bcd8739ae039 = $619d93e693d921a0$var$SvgSearch;



const $aa6f4c7dc0f5685c$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "searchbar__Wrapper",
    componentId: "sc-1lxp2tc-0"
})([
    "",
    " position:relative;width:278px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $aa6f4c7dc0f5685c$var$StyledField = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $2677d04b7028c72d$export$2e2bcd8739ae039)).withConfig({
    displayName: "searchbar__StyledField",
    componentId: "sc-1lxp2tc-1"
})([
    "height:100%;width:100%;input{padding:14px 16px 14px 40px;}"
]);
const $aa6f4c7dc0f5685c$var$StyledSearchIcon = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $619d93e693d921a0$export$2e2bcd8739ae039)).withConfig({
    displayName: "searchbar__StyledSearchIcon",
    componentId: "sc-1lxp2tc-2"
})([
    "position:absolute;left:16px;top:50%;transform:translateY(-50%);width:16px;height:16px;max-width:16px;max-height:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $aa6f4c7dc0f5685c$var$Searchbar = ({ className: className, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($aa6f4c7dc0f5685c$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($aa6f4c7dc0f5685c$var$StyledField, {
                placeholder: "Search",
                ...props
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($aa6f4c7dc0f5685c$var$StyledSearchIcon, {})
        ]
    });
var $aa6f4c7dc0f5685c$export$2e2bcd8739ae039 = $aa6f4c7dc0f5685c$var$Searchbar;











const $870ba58bccab6eec$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "textarea__Wrapper",
    componentId: "sc-bi4jd2-0"
})([
    "",
    " height:115px;width:400px;position:relative;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $870ba58bccab6eec$var$StyledTextarea = (0, ($parcel$interopDefault($jXom6$styledcomponents))).textarea.withConfig({
    displayName: "textarea__StyledTextarea",
    componentId: "sc-bi4jd2-1"
})([
    "resize:none;padding:16px;display:block;font-family:inherit;",
    ""
], (0, $2677d04b7028c72d$export$ceeb223748e25cf7));
const $870ba58bccab6eec$var$StyledSVG = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "textarea__StyledSVG",
    componentId: "sc-bi4jd2-2"
})([
    ""
]);
const $870ba58bccab6eec$var$Message = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "textarea__Message",
    componentId: "sc-bi4jd2-3"
})([
    "margin-top:12px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $870ba58bccab6eec$var$StyledSVG, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), (0, $2677d04b7028c72d$export$ce7158e6888ab5d6));
const $870ba58bccab6eec$var$StyledSmall = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "textarea__StyledSmall",
    componentId: "sc-bi4jd2-4"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), (0, $2677d04b7028c72d$export$ce7158e6888ab5d6));
const $870ba58bccab6eec$var$Textarea = ({ message: message, variant: variant, className: className, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($870ba58bccab6eec$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($870ba58bccab6eec$var$StyledTextarea, {
                variant: variant,
                ...props
            }),
            message && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($870ba58bccab6eec$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1fbc1df023618cf8$export$2e2bcd8739ae039), {
                        className: $870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $773dfb225348757e$export$2e2bcd8739ae039), {
                        className: $870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1055d191a5da0897$export$2e2bcd8739ae039), {
                        className: $870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $3b81fb62e49a97d5$export$2e2bcd8739ae039), {
                        className: $870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($870ba58bccab6eec$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$870ba58bccab6eec$var$Textarea.displayName = "Textarea";
var $870ba58bccab6eec$export$2e2bcd8739ae039 = $870ba58bccab6eec$var$Textarea;












const $ba3b8df995d5886a$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "handle__Wrapper",
    componentId: "sc-no0w1x-0"
})([
    "",
    " display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:relative;top:8px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $ba3b8df995d5886a$var$Label = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "handle__Label",
    componentId: "sc-no0w1x-1"
})([
    "position:relative;left:",
    "%;transform:translateX(-50%);bottom:44px;color:",
    ";"
], ({ offset: offset })=>offset, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $ba3b8df995d5886a$var$StyledHandle = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $jXom6$rcslider.Handle)).withConfig({
    displayName: "handle__StyledHandle",
    componentId: "sc-no0w1x-2"
})([
    "width:30px;height:30px;margin-top:-19px;border:3px solid ",
    ";background-color:",
    ";:hover{cursor:pointer;border-color:",
    ";}:active{box-shadow:0 0 5px ",
    ";}"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $ba3b8df995d5886a$var$Handle = ({ label: label, dragging: dragging, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($ba3b8df995d5886a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($ba3b8df995d5886a$var$Label, {
                offset: props.offset,
                children: label
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($ba3b8df995d5886a$var$StyledHandle, {
                dragging: dragging.toString(),
                ...props
            })
        ]
    });
var $ba3b8df995d5886a$export$2e2bcd8739ae039 = $ba3b8df995d5886a$var$Handle;




const $409b8f5f63cd4acf$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "slider__Wrapper",
    componentId: "sc-5b6ug3-0"
})([
    "",
    " width:500px;margin-top:30px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $409b8f5f63cd4acf$var$StyledSlider = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, ($parcel$interopDefault($jXom6$rcslider)))).withConfig({
    displayName: "slider__StyledSlider",
    componentId: "sc-5b6ug3-1"
})([
    "width:100%;.rc-slider-handle-click-focused:focus{border-color:",
    ";}"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $409b8f5f63cd4acf$var$StyledLabel = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "slider__StyledLabel",
    componentId: "sc-5b6ug3-2"
})([
    "",
    " color:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), (props)=>props.theme.klerosUIComponentsPrimaryText);
const $409b8f5f63cd4acf$var$Labels = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "slider__Labels",
    componentId: "sc-5b6ug3-3"
})([
    "width:100%;margin-top:16px;display:flex;align-items:center;justify-content:space-between;"
]);
const $409b8f5f63cd4acf$var$Slider = ({ label: label, min: min, max: max, leftLabel: leftLabel, rightLabel: rightLabel, callback: callback, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($409b8f5f63cd4acf$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($409b8f5f63cd4acf$var$StyledSlider, {
                handle: ({ ref: ignored, ...handleProps })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $ba3b8df995d5886a$export$2e2bcd8739ae039), {
                        label: label,
                        ...handleProps
                    }),
                railStyle: {
                    height: "8px",
                    backgroundColor: props.theme.klerosUIComponentsStroke,
                    borderRadius: "30px",
                    cursor: "pointer"
                },
                trackStyle: [
                    {
                        height: "8px",
                        backgroundColor: props.theme.klerosUIComponentsPrimaryBlue,
                        borderRadius: "30px",
                        cursor: "pointer"
                    }
                ],
                onChange: callback,
                min: min,
                max: max,
                ...props
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($409b8f5f63cd4acf$var$Labels, {
                children: [
                    leftLabel && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($409b8f5f63cd4acf$var$StyledLabel, {
                        children: leftLabel
                    }),
                    rightLabel && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($409b8f5f63cd4acf$var$StyledLabel, {
                        children: rightLabel
                    })
                ]
            })
        ]
    });
$409b8f5f63cd4acf$var$Slider.displayName = "Slider";
var $409b8f5f63cd4acf$export$2e2bcd8739ae039 = (0, $jXom6$styledcomponents.withTheme)($409b8f5f63cd4acf$var$Slider);







const $a9ca8be356aca825$var$SvgUploadIcon = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M8.406 5.378h2.371V16.91c0 .15.116.273.257.273h1.925c.142 0 .257-.123.257-.273V5.378h2.378c.215 0 .333-.263.202-.44L12.202.105a.26.26 0 0 0-.09-.077.244.244 0 0 0-.224 0 .26.26 0 0 0-.09.077l-3.594 4.83c-.131.18-.013.443.202.443Zm15.337 10.51h-1.925c-.141 0-.257.122-.257.272v5.25H2.44v-5.25c0-.15-.116-.273-.257-.273H.257c-.141 0-.257.123-.257.273v6.75C0 23.511.459 24 1.027 24h21.946c.568 0 1.027-.488 1.027-1.09v-6.75c0-.15-.116-.273-.257-.273Z"
        })
    });
var $a9ca8be356aca825$export$2e2bcd8739ae039 = $a9ca8be356aca825$var$SvgUploadIcon;








const $eab617fde0d2a814$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "file-uploader__Wrapper",
    componentId: "sc-18nhvs2-0"
})([
    "",
    " width:200px;height:64px;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $eab617fde0d2a814$var$DropZone = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "file-uploader__DropZone",
    componentId: "sc-18nhvs2-1"
})([
    "",
    " height:100%;width:100%;background:",
    ";border:1px dashed ",
    ";border-radius:3px;display:flex;justify-content:center;align-items:center;font-size:14px;color:",
    ";"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $eab617fde0d2a814$var$StyledUploadIcon = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $a9ca8be356aca825$export$2e2bcd8739ae039)).withConfig({
    displayName: "file-uploader__StyledUploadIcon",
    componentId: "sc-18nhvs2-2"
})([
    "",
    " height:24px;width:24px;fill:",
    ";"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $eab617fde0d2a814$var$FileInput = (0, ($parcel$interopDefault($jXom6$styledcomponents))).input.withConfig({
    displayName: "file-uploader__FileInput",
    componentId: "sc-18nhvs2-3"
})([
    "display:none;"
]);
const $eab617fde0d2a814$var$StyledSmall = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "file-uploader__StyledSmall",
    componentId: "sc-18nhvs2-4"
})([
    "",
    " position:relative;top:-1px;text-align:justify;color:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), (0, $2677d04b7028c72d$export$ce7158e6888ab5d6));
const $eab617fde0d2a814$var$StyledSVG = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "file-uploader__StyledSVG",
    componentId: "sc-18nhvs2-5"
})([
    ""
]);
const $eab617fde0d2a814$var$Message = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "file-uploader__Message",
    componentId: "sc-18nhvs2-6"
})([
    "margin-top:16px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $eab617fde0d2a814$var$StyledSVG, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), (0, $2677d04b7028c72d$export$ce7158e6888ab5d6));
const $eab617fde0d2a814$var$FileUploader = ({ callback: callback, msg: msg, variant: variant, className: className, ...props })=>{
    const fileInputRef = (0, $jXom6$react.useRef)(); //! type
    const [fileSelected, setFileSelected] = (0, $jXom6$react.useState)();
    const handleDragEnter = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragLeave = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        fileInputRef.current.files = event.dataTransfer?.files;
        setFileSelected(event.dataTransfer?.files[0]);
        callback(event.dataTransfer?.files[0]);
    };
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($eab617fde0d2a814$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($eab617fde0d2a814$var$DropZone, {
                onClick: ()=>fileInputRef?.current.click(),
                onDrop: (e)=>handleDrop(e),
                onDragOver: (e)=>handleDragOver(e),
                onDragEnter: (e)=>handleDragEnter(e),
                onDragLeave: (e)=>handleDragLeave(e),
                children: fileSelected ? fileSelected.name : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($eab617fde0d2a814$var$StyledUploadIcon, {})
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($eab617fde0d2a814$var$FileInput, {
                ref: fileInputRef,
                type: "file",
                onChange: (event)=>{
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setFileSelected(event.target.files[0]);
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    callback(event.target.files[0]);
                },
                ...props
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($eab617fde0d2a814$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1fbc1df023618cf8$export$2e2bcd8739ae039), {
                        className: $eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $773dfb225348757e$export$2e2bcd8739ae039), {
                        className: $eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1055d191a5da0897$export$2e2bcd8739ae039), {
                        className: $eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $3b81fb62e49a97d5$export$2e2bcd8739ae039), {
                        className: $eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($eab617fde0d2a814$var$StyledSmall, {
                        variant: variant,
                        children: msg
                    })
                ]
            })
        ]
    });
};
var $eab617fde0d2a814$export$2e2bcd8739ae039 = $eab617fde0d2a814$var$FileUploader;








const $1a85d5c881834fd9$var$datepickerContextDefaultValue = {
    focusedDate: null,
    isDateFocused: ()=>false,
    isDateSelected: ()=>false,
    isDateHovered: ()=>false,
    isDateBlocked: ()=>false,
    isFirstOrLastSelectedDate: ()=>false,
    onDateFocus: ()=>{
    //do nothing
    },
    onDateHover: ()=>{
    //do nothing
    },
    onDateSelect: ()=>{
    //do nothing
    }
};
var $1a85d5c881834fd9$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($jXom6$react))).createContext($1a85d5c881834fd9$var$datepickerContextDefaultValue);







const $8da322913a568d32$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M5.625 9h-1.25A.376.376 0 0 1 4 8.625v-1.25C4 7.169 4.169 7 4.375 7h1.25c.206 0 .375.169.375.375v1.25A.376.376 0 0 1 5.625 9ZM9 8.625v-1.25A.376.376 0 0 0 8.625 7h-1.25A.376.376 0 0 0 7 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 8.625Zm3 0v-1.25A.376.376 0 0 0 11.625 7h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 12 8.625Zm-3 3v-1.25A.376.376 0 0 0 8.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 11.625Zm-3 0v-1.25A.376.376 0 0 0 5.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 6 11.625Zm6 0v-1.25a.376.376 0 0 0-.375-.375h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 0 0 .375-.375ZM15 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5v-11A1.5 1.5 0 0 1 2.5 2H4V.375C4 .169 4.169 0 4.375 0h1.25C5.831 0 6 .169 6 .375V2h4V.375c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V2h1.5A1.5 1.5 0 0 1 15 3.5Zm-1.5 10.813V5h-11v9.313c0 .103.084.187.188.187h10.624a.188.188 0 0 0 .188-.188Z"
        })
    });
var $8da322913a568d32$export$2e2bcd8739ae039 = $8da322913a568d32$var$SvgCalendar;



const $02569186343496d4$var$StyledButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "display-button__StyledButton",
    componentId: "sc-1n9stdw-0"
})([
    "",
    " height:45px;width:330px;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:0px 16px;display:flex;justify-content:flex-start;align-items:center;"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $02569186343496d4$var$StyledDate = (0, ($parcel$interopDefault($jXom6$styledcomponents))).p.withConfig({
    displayName: "display-button__StyledDate",
    componentId: "sc-1n9stdw-1"
})([
    "",
    ""
], (0, $49a276e58256b44f$export$ffb5f4729a158638));
const $02569186343496d4$var$StyledCalendar = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $8da322913a568d32$export$2e2bcd8739ae039)).withConfig({
    displayName: "display-button__StyledCalendar",
    componentId: "sc-1n9stdw-2"
})([
    "position:absolute;right:16px;height:16px;width:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $02569186343496d4$var$DisplayButton = ({ onClick: onClick, date: date, time: time })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($02569186343496d4$var$StyledButton, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($02569186343496d4$var$StyledDate, {
                children: [
                    date.toLocaleDateString(),
                    time && `, ${date.getHours().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })}:${date.getMinutes().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })} Local time`
                ]
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($02569186343496d4$var$StyledCalendar, {})
        ]
    });
var $02569186343496d4$export$2e2bcd8739ae039 = $02569186343496d4$var$DisplayButton;


















const $1a3cb6cad04c22a8$var$StyledDayNumber = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "day__StyledDayNumber",
    componentId: "sc-1cckfjj-0"
})([
    "",
    " color:",
    " !important;font-weight:600;cursor:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), (props)=>props.isSelected ? props.theme.klerosUIComponentsWhiteBackground : props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsSecondaryText, (props)=>props.disabledDate ? "not-allowed" : "pointer");
const $1a3cb6cad04c22a8$var$StyledButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "day__StyledButton",
    componentId: "sc-1cckfjj-1"
})([
    "",
    " height:24px;width:24px;border-radius:12px;background-color:",
    ";padding:0;display:flex;justify-content:center;align-items:center;:hover{background-color:",
    ";& ",
    "{color:",
    " !important;}}"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.disabledDate ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsSecondaryBlue, $1a3cb6cad04c22a8$var$StyledDayNumber, (props)=>props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground);
const $1a3cb6cad04c22a8$var$Day = ({ date: date, dayLabel: dayLabel })=>{
    const dayRef = (0, $jXom6$react.useRef)(null);
    const { isSelected: isSelected, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, tabIndex: tabIndex } = (0, $jXom6$datepickerreacthooks.useDay)({
        dayRef: dayRef,
        date: date,
        ...(0, $jXom6$react.useContext)((0, $1a85d5c881834fd9$export$2e2bcd8739ae039))
    });
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isPastDate = date.getTime() < today.getTime();
    const handleClick = ()=>{
        if (!isPastDate) onClick();
    };
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($1a3cb6cad04c22a8$var$StyledButton, {
        ref: dayRef,
        isSelected: isSelected,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        tabIndex: tabIndex,
        disabledDate: isPastDate,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($1a3cb6cad04c22a8$var$StyledDayNumber, {
            isSelected: isSelected,
            disabledDate: isPastDate,
            children: dayLabel
        })
    });
};
var $1a3cb6cad04c22a8$export$2e2bcd8739ae039 = $1a3cb6cad04c22a8$var$Day;



const $b6c83c11430985d2$var$MonthContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "month__MonthContainer",
    componentId: "sc-1lt566d-0"
})([
    "width:330px;height:220px;padding-top:16px;display:flex;justify-content:center;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $b6c83c11430985d2$var$StyledGridContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "month__StyledGridContainer",
    componentId: "sc-1lt566d-1"
})([
    "height:26px;width:32px;display:flex;justify-content:center;align-items:center;"
]);
const $b6c83c11430985d2$var$StyledWeekDay = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "month__StyledWeekDay",
    componentId: "sc-1lt566d-2"
})([
    "",
    " color:",
    ";font-weight:600;user-select:none;"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $b6c83c11430985d2$var$StyledMonth = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "month__StyledMonth",
    componentId: "sc-1lt566d-3"
})([
    "width:fit-content;height:fit-content;display:grid;grid-template-columns:repeat(7,32px);"
]);
const $b6c83c11430985d2$var$Month = ({ days: days, weekdayLabels: weekdayLabels })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b6c83c11430985d2$var$MonthContainer, {
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($b6c83c11430985d2$var$StyledMonth, {
            children: [
                weekdayLabels.map((dayLabel, i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b6c83c11430985d2$var$StyledWeekDay, {
                            children: dayLabel
                        })
                    }, i)),
                days.map((day, i)=>typeof day === "number" ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b6c83c11430985d2$var$StyledGridContainer, {}, i) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1a3cb6cad04c22a8$export$2e2bcd8739ae039), {
                            ...day
                        }, i)
                    }, i))
            ]
        })
    });
var $b6c83c11430985d2$export$2e2bcd8739ae039 = $b6c83c11430985d2$var$Month;







const $51df4a6e8b413d48$var$SvgSimpleLeft = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "m9.197 14.429-.793.786a.859.859 0 0 1-1.21 0L.252 8.335a.841.841 0 0 1 0-1.201L7.194.25a.859.859 0 0 1 1.21 0l.793.786a.846.846 0 0 1-.014 1.214L4.88 6.316h10.263c.475 0 .857.379.857.85v1.133c0 .471-.382.85-.857.85H4.88l4.303 4.065a.84.84 0 0 1 .014 1.215Z"
        })
    });
var $51df4a6e8b413d48$export$2e2bcd8739ae039 = $51df4a6e8b413d48$var$SvgSimpleLeft;



const $d9b6f601d2dcc8ac$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "month-selector__Wrapper",
    componentId: "sc-1tkddgk-0"
})([
    "width:100%;height:64px;padding:24px;display:flex;justify-content:space-between;"
]);
const $d9b6f601d2dcc8ac$var$StyledMonthTitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h2.withConfig({
    displayName: "month-selector__StyledMonthTitle",
    componentId: "sc-1tkddgk-1"
})([
    "",
    " user-select:none;"
], (0, $49a276e58256b44f$export$a943aa9a0fca3f0b));
const $d9b6f601d2dcc8ac$var$StyledArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $51df4a6e8b413d48$export$2e2bcd8739ae039)).withConfig({
    displayName: "month-selector__StyledArrow",
    componentId: "sc-1tkddgk-2"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";:hover{fill:",
    ";}"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $d9b6f601d2dcc8ac$var$RightArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($d9b6f601d2dcc8ac$var$StyledArrow).withConfig({
    displayName: "month-selector__RightArrow",
    componentId: "sc-1tkddgk-3"
})([
    "transform:rotate(180deg);"
]);
const $d9b6f601d2dcc8ac$var$UnstyledButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "month-selector__UnstyledButton",
    componentId: "sc-1tkddgk-4"
})([
    "",
    " background:none;padding:0;"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6));
const $d9b6f601d2dcc8ac$var$MonthSelector = ({ monthLabel: monthLabel, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d9b6f601d2dcc8ac$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToPreviousMonths,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d9b6f601d2dcc8ac$var$StyledArrow, {})
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d9b6f601d2dcc8ac$var$StyledMonthTitle, {
                children: monthLabel
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToNextMonths,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d9b6f601d2dcc8ac$var$RightArrow, {})
            })
        ]
    });
var $d9b6f601d2dcc8ac$export$2e2bcd8739ae039 = $d9b6f601d2dcc8ac$var$MonthSelector;


const $5b91024d35847b4a$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "date-selector__Wrapper",
    componentId: "sc-dxn9nj-0"
})([
    "display:flex;flex-direction:column;"
]);
const $5b91024d35847b4a$var$DateSelector = ({ year: year, month: month, firstDayOfWeek: firstDayOfWeek, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>{
    const { days: days, weekdayLabels: weekdayLabels, monthLabel: monthLabel } = (0, $jXom6$datepickerreacthooks.useMonth)({
        year: year,
        month: month,
        firstDayOfWeek: firstDayOfWeek
    });
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($5b91024d35847b4a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $d9b6f601d2dcc8ac$export$2e2bcd8739ae039), {
                monthLabel: monthLabel,
                goToPreviousMonths: goToPreviousMonths,
                goToNextMonths: goToNextMonths
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $b6c83c11430985d2$export$2e2bcd8739ae039), {
                days: days,
                weekdayLabels: weekdayLabels
            })
        ]
    });
};
var $5b91024d35847b4a$export$2e2bcd8739ae039 = $5b91024d35847b4a$var$DateSelector;










const $2dfb31ff65652603$var$TimeControl = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "time-controls__TimeControl",
    componentId: "sc-198k8z7-0"
})([
    "flex-grow:1;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";display:flex;flex-direction:column;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $2dfb31ff65652603$var$TimeDisplay = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "time-controls__TimeDisplay",
    componentId: "sc-198k8z7-1"
})([
    "width:100%;height:64px;background-color:",
    ";padding:0px 24px;display:flex;justify-content:space-between;align-items:center;"
], ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
const $2dfb31ff65652603$var$StyledTime = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "time-controls__StyledTime",
    componentId: "sc-198k8z7-2"
})([
    "",
    " font-weight:600;color:",
    ";user-select:none;"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $2dfb31ff65652603$var$TimeButtons = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($2dfb31ff65652603$var$TimeDisplay).withConfig({
    displayName: "time-controls__TimeButtons",
    componentId: "sc-198k8z7-3"
})([
    "flex-grow:1;background-color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $2dfb31ff65652603$var$StyledArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $51df4a6e8b413d48$export$2e2bcd8739ae039)).withConfig({
    displayName: "time-controls__StyledArrow",
    componentId: "sc-198k8z7-4"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $2dfb31ff65652603$var$UpArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__UpArrow",
    componentId: "sc-198k8z7-5"
})([
    "transform:rotate(90deg);"
]);
const $2dfb31ff65652603$var$DownArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__DownArrow",
    componentId: "sc-198k8z7-6"
})([
    "transform:rotate(-90deg);"
]);
const $2dfb31ff65652603$var$UnstyledButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "time-controls__UnstyledButton",
    componentId: "sc-198k8z7-7"
})([
    "",
    " background:none;padding:0;:hover{& ",
    "{fill:",
    ";}}:disabled{& ",
    "{fill:",
    ";}}"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), $2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue, $2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $2dfb31ff65652603$var$TimeControls = ({ date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes })=>{
    const today = new Date();
    const disableHourUp = hours === 23;
    const disableMinuteUp = minutes === 59;
    const isToday = date.toDateString() === today.toDateString();
    const currentTime = today.getTime();
    const checkTime = new Date(date).setHours(hours - 1, minutes);
    const disableHourDown = hours === 0 || isToday && (hours - 1 < today.getHours() || hours - 1 === today.getHours() && minutes <= today.getMinutes() || checkTime <= currentTime);
    const disableMinuteDown = minutes === 0 || isToday && (hours < today.getHours() || hours === today.getHours() && minutes - 1 <= today.getMinutes());
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($2dfb31ff65652603$var$TimeControl, {
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours + 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourUp,
                        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$UpArrow, {})
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes + 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteUp,
                        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$UpArrow, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($2dfb31ff65652603$var$TimeDisplay, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$StyledTime, {
                        children: hours.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$StyledTime, {
                        children: ":"
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$StyledTime, {
                        children: minutes.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours - 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourDown,
                        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$DownArrow, {})
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes - 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteDown,
                        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2dfb31ff65652603$var$DownArrow, {})
                    })
                ]
            })
        ]
    });
};
var $2dfb31ff65652603$export$2e2bcd8739ae039 = $2dfb31ff65652603$var$TimeControls;



const $a1eb1518e9214887$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "time-selector__Wrapper",
    componentId: "sc-1i0y3my-0"
})([
    "width:118px;height:284px;border-left:1px solid ",
    ";display:flex;flex-direction:column;",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "border:1px solid ",
        ";border-top:none;border-bottom:none;"
    ], ({ theme: theme })=>theme.klerosUIComponentsStroke)));
const $a1eb1518e9214887$var$Header = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "time-selector__Header",
    componentId: "sc-1i0y3my-1"
})([
    "height:64px;display:flex;justify-content:center;align-items:center;"
]);
const $a1eb1518e9214887$var$StyledTitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h2.withConfig({
    displayName: "time-selector__StyledTitle",
    componentId: "sc-1i0y3my-2"
})([
    "",
    " user-select:none;"
], (0, $49a276e58256b44f$export$a943aa9a0fca3f0b));
const $a1eb1518e9214887$var$TimeSelector = (props)=>{
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($a1eb1518e9214887$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a1eb1518e9214887$var$Header, {
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a1eb1518e9214887$var$StyledTitle, {
                    children: "Time"
                })
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2dfb31ff65652603$export$2e2bcd8739ae039), {
                ...props
            })
        ]
    });
};
var $a1eb1518e9214887$export$2e2bcd8739ae039 = $a1eb1518e9214887$var$TimeSelector;




const $275ab796fce9757e$var$Container = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "dropdown__Container",
    componentId: "sc-xqzukb-0"
})([
    "position:absolute;z-index:100;overflow:hidden;height:",
    ";width:",
    ";transition:height ease ",
    ";background:",
    ";",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:3px;",
    ""
], ({ isOpen: isOpen })=>isOpen ? "auto" : "0", ({ time: time })=>time ? "450px" : "330px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ isOpen: isOpen, theme: theme })=>isOpen ? `border: 1px solid ${theme.klerosUIComponentsStroke}` : "", ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "width:332px;position:static;margin:0;left:0;top:0;"
    ])));
const $275ab796fce9757e$var$Selectors = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "dropdown__Selectors",
    componentId: "sc-xqzukb-1"
})([
    "display:flex;",
    ""
], (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "flex-direction:column;align-items:center;justify-content:flex-start;"
    ])));
const $275ab796fce9757e$var$ButtonContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "dropdown__ButtonContainer",
    componentId: "sc-xqzukb-2"
})([
    "width:100%;padding:16px 24px;display:flex;justify-content:flex-end;align-items:center;",
    ""
], (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "justify-content:center;"
    ])));
const $275ab796fce9757e$var$Dropdown = ({ onSelect: onSelect, isOpen: isOpen, time: time, date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes, ...dateSelectorProps })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($275ab796fce9757e$var$Container, {
        isOpen: isOpen,
        time: time,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($275ab796fce9757e$var$Selectors, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $5b91024d35847b4a$export$2e2bcd8739ae039), {
                        ...dateSelectorProps
                    }),
                    time && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $a1eb1518e9214887$export$2e2bcd8739ae039), {
                        date: date,
                        hours: hours,
                        minutes: minutes,
                        setHours: setHours,
                        setMinutes: setMinutes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($275ab796fce9757e$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2987665db72ba3c1$export$2e2bcd8739ae039), {
                    small: true,
                    variant: "primary",
                    text: "Select",
                    onClick: onSelect
                })
            })
        ]
    });
var $275ab796fce9757e$export$2e2bcd8739ae039 = $275ab796fce9757e$var$Dropdown;



const $1d445195934320ed$var$PositionedContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "datepicker__PositionedContainer",
    componentId: "sc-1gv6m20-0"
})([
    "",
    " position:relative;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $1d445195934320ed$var$DatePicker = ({ onSelect: onSelect, time: time })=>{
    const [isOpen, setIsOpen] = (0, $jXom6$react.useState)(false);
    const containerRef = (0, $jXom6$react.useRef)(null);
    (0, $bfcc265ae6655ec9$export$2e2bcd8739ae039)(containerRef, ()=>setIsOpen(false));
    const [date, setDate] = (0, $jXom6$react.useState)(new Date());
    const [hours, setHours] = (0, $jXom6$react.useState)(date.getHours());
    const [minutes, setMinutes] = (0, $jXom6$react.useState)(date.getMinutes());
    const today = new Date();
    const lastSelectableDate = new Date(today);
    lastSelectableDate.setDate(today.getDate());
    const updateDateWithTime = (selectedDate)=>{
        if (selectedDate.toDateString() === lastSelectableDate.toDateString()) {
            const now = new Date();
            selectedDate.setHours(now.getHours(), now.getMinutes());
            setHours(now.getHours());
            setMinutes(now.getMinutes());
        } else selectedDate.setHours(hours, minutes);
        setDate(selectedDate);
        onSelect(selectedDate);
    };
    const { firstDayOfWeek: firstDayOfWeek, activeMonths: activeMonths, isDateHovered: isDateHovered, isFirstOrLastSelectedDate: isFirstOrLastSelectedDate, isDateBlocked: isDateBlocked, isDateFocused: isDateFocused, focusedDate: focusedDate, onDateHover: onDateHover, onDateSelect: handleDateSelect, onDateFocus: onDateFocus, goToPreviousMonths: goToPreviousMonths, goToNextMonths: goToNextMonths } = (0, $jXom6$datepickerreacthooks.useDatepicker)({
        startDate: date,
        endDate: date,
        focusedInput: (0, $jXom6$datepickerreacthooks.START_DATE),
        onDatesChange: (data)=>{
            if (data.startDate) updateDateWithTime(new Date(data.startDate));
        },
        numberOfMonths: 1,
        minBookingDays: 1,
        exactMinBookingDays: true
    });
    const onTimeChange = (newHours, newMinutes)=>{
        const newDate = new Date(date);
        newDate.setHours(newHours, newMinutes);
        setHours(newHours);
        setMinutes(newMinutes);
        setDate(newDate);
        onSelect(newDate);
    };
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1a85d5c881834fd9$export$2e2bcd8739ae039).Provider, {
        value: {
            focusedDate: focusedDate,
            isDateFocused: isDateFocused,
            isDateSelected: (selectedDate)=>{
                return selectedDate.getDate() === date.getDate() && selectedDate.getMonth() === date.getMonth() && selectedDate.getFullYear() === date.getFullYear();
            },
            isDateHovered: isDateHovered,
            isDateBlocked: isDateBlocked,
            isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
            onDateSelect: (selectedDate)=>{
                handleDateSelect(selectedDate);
                updateDateWithTime(selectedDate);
            },
            onDateFocus: onDateFocus,
            onDateHover: onDateHover
        },
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($1d445195934320ed$var$PositionedContainer, {
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $02569186343496d4$export$2e2bcd8739ae039), {
                    date: date,
                    time: time,
                    onClick: ()=>setIsOpen(!isOpen)
                }),
                /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $275ab796fce9757e$export$2e2bcd8739ae039), {
                    ...activeMonths[0],
                    isOpen: isOpen,
                    time: time,
                    firstDayOfWeek: firstDayOfWeek,
                    goToNextMonths: goToNextMonths,
                    goToPreviousMonths: goToPreviousMonths,
                    date: date,
                    hours: hours,
                    minutes: minutes,
                    setHours: (newHours)=>onTimeChange(newHours, minutes),
                    setMinutes: (newMinutes)=>onTimeChange(hours, newMinutes),
                    onSelect: ()=>{
                        date.setHours(hours, minutes);
                        onSelect(date);
                        setIsOpen(false);
                    }
                })
            ]
        })
    });
};
var $1d445195934320ed$export$2e2bcd8739ae039 = $1d445195934320ed$var$DatePicker;






const $86e1d79a67710eda$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).label.withConfig({
    displayName: "radio__Wrapper",
    componentId: "sc-1jhzktg-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $jXom6$styledcomponents.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $jXom6$styledcomponents.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $86e1d79a67710eda$var$HiddenInput = (0, ($parcel$interopDefault($jXom6$styledcomponents))).input.attrs({
    type: "radio"
}).withConfig({
    displayName: "radio__HiddenInput",
    componentId: "sc-1jhzktg-1"
})([
    "position:absolute;opacity:0;cursor:pointer;"
]);
const $86e1d79a67710eda$var$StyledRadio = (0, ($parcel$interopDefault($jXom6$styledcomponents))).span.withConfig({
    displayName: "radio__StyledRadio",
    componentId: "sc-1jhzktg-2"
})([
    "position:absolute;top:0;left:0;border:1px solid ",
    ";border-radius:50%;",
    ' :after{content:"";position:absolute;display:none;border-radius:50%;background:',
    ";",
    "}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? (0, $jXom6$styledcomponents.css)([
        "width:16px;height:16px;"
    ]) : (0, $jXom6$styledcomponents.css)([
        "width:24px;height:24px;"
    ]), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? (0, $jXom6$styledcomponents.css)([
        "top:3px;left:3px;width:8px;height:8px;"
    ]) : (0, $jXom6$styledcomponents.css)([
        "top:5px;left:5px;width:12px;height:12px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $jXom6$styledcomponents.css)([
        "background:",
        ";border:1px solid ",
        ";:after{display:block;}"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsPrimaryBlue));
const $86e1d79a67710eda$var$Radio = ({ small: small, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($86e1d79a67710eda$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($86e1d79a67710eda$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($86e1d79a67710eda$var$StyledRadio, {
                small: small,
                checked: checked
            })
        ]
    });
var $86e1d79a67710eda$export$2e2bcd8739ae039 = $86e1d79a67710eda$var$Radio;







const $1d196f635349b3e7$var$SvgCheckmark = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 15 12",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M14.416 0h-1.77c-.384 0-.75.185-.977.502L5.737 8.729 3.05 5a1.207 1.207 0 0 0-.978-.502H.302c-.245 0-.388.28-.245.48l4.702 6.52a1.2 1.2 0 0 0 1.951 0L14.658.48A.3.3 0 0 0 14.416 0Z",
            fill: "#fff"
        })
    });
var $1d196f635349b3e7$export$2e2bcd8739ae039 = $1d196f635349b3e7$var$SvgCheckmark;



const $b679852ecf8e9c02$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).label.withConfig({
    displayName: "checkbox__Wrapper",
    componentId: "sc-1qpo0fn-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $jXom6$styledcomponents.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $jXom6$styledcomponents.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $b679852ecf8e9c02$var$HiddenInput = (0, ($parcel$interopDefault($jXom6$styledcomponents))).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "checkbox__HiddenInput",
    componentId: "sc-1qpo0fn-1"
})([
    "position:absolute;opacity:0;cursor:pointer;height:0;width:0;"
]);
const $b679852ecf8e9c02$var$StyledCheckmark = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $1d196f635349b3e7$export$2e2bcd8739ae039)).withConfig({
    displayName: "checkbox__StyledCheckmark",
    componentId: "sc-1qpo0fn-2"
})([
    "",
    " position:absolute;top:0;left:0;border-radius:3px;border:1px solid ",
    ";",
    " ",
    ""
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ $small: $small })=>$small ? (0, $jXom6$styledcomponents.css)([
        "padding:0 3px;width:16px;height:16px;"
    ]) : (0, $jXom6$styledcomponents.css)([
        "padding:0 4px;width:24px;height:24px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $jXom6$styledcomponents.css)([
        "background:",
        ";border:none;:after{display:block;}"
    ], theme.klerosUIComponentsPrimaryBlue));
const $b679852ecf8e9c02$var$Checkbox = ({ small: small = false, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($b679852ecf8e9c02$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b679852ecf8e9c02$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b679852ecf8e9c02$var$StyledCheckmark, {
                $small: small,
                checked: checked
            })
        ]
    });
var $b679852ecf8e9c02$export$2e2bcd8739ae039 = $b679852ecf8e9c02$var$Checkbox;






const $34871b0f15f7c161$var$StyledSwitch = (0, ($parcel$interopDefault($jXom6$styledcomponents))).label.withConfig({
    displayName: "switch__StyledSwitch",
    componentId: "sc-1or3qt0-0"
})([
    "",
    " position:relative;display:inline-block;height:",
    ";width:",
    ";"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ small: small })=>small ? "16px" : "24px", ({ small: small })=>small ? "32px" : "48px");
const $34871b0f15f7c161$var$HiddenInput = (0, ($parcel$interopDefault($jXom6$styledcomponents))).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "switch__HiddenInput",
    componentId: "sc-1or3qt0-1"
})([
    "opacity:0;width:0;height:0;"
]);
const $34871b0f15f7c161$var$StyledSlider = (0, ($parcel$interopDefault($jXom6$styledcomponents))).span.withConfig({
    displayName: "switch__StyledSlider",
    componentId: "sc-1or3qt0-2"
})([
    "position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:",
    ';transition:0.4s;border-radius:34px;&:before{position:absolute;content:"";height:',
    ";width:",
    ";left:2px;bottom:2px;border-radius:50%;background-color:white;transition:0.4s;}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? "12px" : "20px", ({ small: small })=>small ? "12px" : "20px", ({ checked: checked, theme: theme, small: small })=>checked && (0, $jXom6$styledcomponents.css)([
        "background-color:",
        ";:before{transform:translateX(",
        ");}"
    ], theme.klerosUIComponentsPrimaryBlue, small ? "16px" : "24px"));
const $34871b0f15f7c161$var$Switch = ({ small: small, checked: checked, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($34871b0f15f7c161$var$StyledSwitch, {
        small: small,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($34871b0f15f7c161$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($34871b0f15f7c161$var$StyledSlider, {
                small: small,
                checked: checked
            })
        ]
    });
var $34871b0f15f7c161$export$2e2bcd8739ae039 = $34871b0f15f7c161$var$Switch;










const $d963730b715e990c$var$variantColor = (0, $jXom6$styledcomponents.css)([
    "",
    ""
], ({ theme: theme, variant: variant })=>{
    switch(variant){
        case "success":
            return (0, $jXom6$styledcomponents.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsSuccess);
        case "warning":
            return (0, $jXom6$styledcomponents.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsWarning);
        case "error":
            return (0, $jXom6$styledcomponents.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsError);
        case "info":
        default:
            return (0, $jXom6$styledcomponents.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsPrimaryBlue);
    }
});
const $d963730b715e990c$var$borderColor = ({ theme: theme, variant: variant })=>{
    const colors = {
        success: theme.klerosUIComponentsSuccess,
        warning: theme.klerosUIComponentsWarning,
        error: theme.klerosUIComponentsError,
        info: theme.klerosUIComponentsPrimaryBlue
    };
    return colors[variant];
};
const $d963730b715e990c$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "alert__Wrapper",
    componentId: "sc-rckqp0-0"
})([
    "display:grid;grid-template-columns:24px auto;gap:16px;align-items:center;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:16px 24px 20px 24px;"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme, variant: variant })=>$d963730b715e990c$var$borderColor({
        theme: theme,
        variant: variant
    }));
const $d963730b715e990c$var$IconWrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "alert__IconWrapper",
    componentId: "sc-rckqp0-1"
})([
    "",
    " height:24px;width:24px;svg{",
    " fill:currentColor;}"
], $d963730b715e990c$var$variantColor, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68));
const $d963730b715e990c$var$StyledTitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h2.withConfig({
    displayName: "alert__StyledTitle",
    componentId: "sc-rckqp0-2"
})([
    "",
    " font-size:16px;margin:0;font-weight:600;line-height:24px;"
], $d963730b715e990c$var$variantColor);
const $d963730b715e990c$var$TitleAndMessage = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "alert__TitleAndMessage",
    componentId: "sc-rckqp0-3"
})([
    "display:flex;flex-direction:column;",
    ";"
], (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "gap:8px;"
    ])));
const $d963730b715e990c$var$StyledMessage = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "alert__StyledMessage",
    componentId: "sc-rckqp0-4"
})([
    "color:",
    ";font-weight:400;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $d963730b715e990c$var$Alert = ({ variant: variant, title: title, msg: msg })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d963730b715e990c$var$Wrapper, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d963730b715e990c$var$IconWrapper, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1fbc1df023618cf8$export$2e2bcd8739ae039), {}),
                    variant === "warning" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $773dfb225348757e$export$2e2bcd8739ae039), {}),
                    variant === "error" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1055d191a5da0897$export$2e2bcd8739ae039), {}),
                    variant === "info" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $3b81fb62e49a97d5$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($d963730b715e990c$var$TitleAndMessage, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d963730b715e990c$var$StyledTitle, {
                        variant: variant,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($d963730b715e990c$var$StyledMessage, {
                        children: msg
                    })
                ]
            })
        ]
    });
var $d963730b715e990c$export$2e2bcd8739ae039 = $d963730b715e990c$var$Alert;







const $296cff7698ec0f63$var$SvgSolidSuccess = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm6.91 10.775-7.52 10.429a1.136 1.136 0 0 1-1.847 0l-4.454-6.172a.287.287 0 0 1 .232-.453h1.675c.365 0 .711.175.925.475l2.543 3.528 5.615-7.785c.214-.297.557-.475.925-.475h1.675c.232 0 .367.264.232.453Z"
        })
    });
var $296cff7698ec0f63$export$2e2bcd8739ae039 = $296cff7698ec0f63$var$SvgSolidSuccess;




const $ff1548a205f71f6a$var$SvgSolidError = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm5.907 22.079-2.357-.011L16 17.836l-3.546 4.228-2.361.011a.284.284 0 0 1-.286-.286c0-.068.025-.132.068-.185l4.646-5.536-4.646-5.532a.287.287 0 0 1 .218-.471l2.36.01L16 14.307l3.546-4.228 2.358-.011c.157 0 .285.125.285.286a.297.297 0 0 1-.068.185l-4.639 5.532 4.643 5.536a.287.287 0 0 1-.218.472Z"
        })
    });
var $ff1548a205f71f6a$export$2e2bcd8739ae039 = $ff1548a205f71f6a$var$SvgSolidError;




const $d6917595109333d4$var$SvgSync = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M2.171 11.777a9.807 9.807 0 0 1 2.874-6.726 9.778 9.778 0 0 1 6.951-2.88c1.33 0 2.615.26 3.824.772a9.757 9.757 0 0 1 3.123 2.108c.283.283.548.583.794.898l-1.72 1.342a.229.229 0 0 0 .086.403l5.02 1.229a.23.23 0 0 0 .283-.22l.023-5.169c0-.191-.22-.3-.369-.18l-1.611 1.26A11.967 11.967 0 0 0 11.994 0C5.45 0 .123 5.246 0 11.766A.228.228 0 0 0 .23 12h1.714c.126 0 .226-.1.228-.223Zm21.6.223h-1.714c-.125 0-.226.1-.228.223a9.76 9.76 0 0 1-.769 3.6 9.778 9.778 0 0 1-2.106 3.126 9.786 9.786 0 0 1-6.951 2.88 9.779 9.779 0 0 1-6.949-2.88 9.853 9.853 0 0 1-.794-.898l1.72-1.342a.23.23 0 0 0 .024-.34.229.229 0 0 0-.11-.063l-5.02-1.229a.23.23 0 0 0-.282.22l-.02 5.172c0 .191.22.3.368.18l1.611-1.26A11.973 11.973 0 0 0 12.006 24C18.554 24 23.877 18.751 24 12.234a.229.229 0 0 0-.229-.234Z"
        })
    });
var $d6917595109333d4$export$2e2bcd8739ae039 = $d6917595109333d4$var$SvgSync;




const $88d96d829ac44aee$var$SvgClose = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 8 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M4.525 4 7.746.16A.098.098 0 0 0 7.671 0h-.979a.2.2 0 0 0-.15.07L3.884 3.237 1.228.07a.196.196 0 0 0-.15-.07h-.98a.098.098 0 0 0-.075.16L3.244 4 .024 7.84A.098.098 0 0 0 .097 8h.98a.2.2 0 0 0 .15-.07l2.657-3.167L6.54 7.93c.037.044.092.07.151.07h.98a.098.098 0 0 0 .074-.16L4.526 4Z"
        })
    });
var $88d96d829ac44aee$export$2e2bcd8739ae039 = $88d96d829ac44aee$var$SvgClose;



const $cadd1c9c3bca1fc9$var$StyledSVG = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "push__StyledSVG",
    componentId: "sc-4wrqai-0"
})([
    ""
]);
const $cadd1c9c3bca1fc9$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "push__Wrapper",
    componentId: "sc-4wrqai-1"
})([
    "",
    " position:relative;height:",
    ";width:",
    ";background:",
    ";border-radius:3px;padding:",
    ";display:flex;align-items:center;& ",
    "{",
    " height:",
    ";width:",
    ";min-height:",
    ";min-width:",
    ";fill:",
    ";}"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ small: small })=>small ? "48px" : "100px", ({ small: small })=>small ? "300px" : "422px", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? "12px 24px 12px 24px" : "16px 32px 16px 24px", $cadd1c9c3bca1fc9$var$StyledSVG, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $cadd1c9c3bca1fc9$var$StyledTitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h2.withConfig({
    displayName: "push__StyledTitle",
    componentId: "sc-4wrqai-2"
})([
    "",
    " color:inherit;"
], (0, $49a276e58256b44f$export$a943aa9a0fca3f0b));
const $cadd1c9c3bca1fc9$var$StyledMessage = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "push__StyledMessage",
    componentId: "sc-4wrqai-3"
})([
    "",
    " color:inherit;"
], (0, $49a276e58256b44f$export$3c17b0e969a90510));
const $cadd1c9c3bca1fc9$var$Text = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "push__Text",
    componentId: "sc-4wrqai-4"
})([
    "margin-left:16px;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $cadd1c9c3bca1fc9$var$CloseButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "push__CloseButton",
    componentId: "sc-4wrqai-5"
})([
    "",
    " position:absolute;top:24px;right:24px;height:8px;width:8px;background:none;padding:0;display:inline-flex;"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6));
const $cadd1c9c3bca1fc9$var$StyledCloseIcon = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $88d96d829ac44aee$export$2e2bcd8739ae039)).withConfig({
    displayName: "push__StyledCloseIcon",
    componentId: "sc-4wrqai-6"
})([
    "",
    " height:8px;width:8px;min-height:8px;min-width:8px;fill:",
    ";"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $cadd1c9c3bca1fc9$var$Push = ({ variant: variant, title: title, msg: msg, callback: callback, small: small, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($cadd1c9c3bca1fc9$var$Wrapper, {
        small: small,
        ...props,
        children: [
            variant === "success" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $296cff7698ec0f63$export$2e2bcd8739ae039), {
                className: $cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "error" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $ff1548a205f71f6a$export$2e2bcd8739ae039), {
                className: $cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "sync" && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $d6917595109333d4$export$2e2bcd8739ae039), {
                className: $cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($cadd1c9c3bca1fc9$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($cadd1c9c3bca1fc9$var$StyledTitle, {
                        children: title
                    }),
                    !small && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($cadd1c9c3bca1fc9$var$StyledMessage, {
                        children: msg
                    })
                ]
            }),
            !small && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($cadd1c9c3bca1fc9$var$CloseButton, {
                onClick: ()=>callback(),
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($cadd1c9c3bca1fc9$var$StyledCloseIcon, {})
            })
        ]
    });
var $cadd1c9c3bca1fc9$export$2e2bcd8739ae039 = $cadd1c9c3bca1fc9$var$Push;





const $0ef3fc8611d56815$var$usePagination = (currentPage, numPages, callback, numNeighbors = 2)=>{
    const incrementPage = ()=>{
        const newPage = Math.min(numPages, currentPage + 1);
        callback(newPage);
    };
    const decrementPage = ()=>{
        const newPage = Math.max(1, currentPage - 1);
        callback(newPage);
    };
    const goToPage = (newPage)=>{
        callback(newPage);
    };
    const minPageReached = currentPage === 1;
    const maxPageReached = currentPage === numPages;
    const getPageRange = ()=>{
        const leftBoundary = Math.max(1, currentPage - numNeighbors - Math.max(0, numNeighbors - (numPages - currentPage)));
        const rightBoundary = Math.min(numPages, currentPage + numNeighbors + Math.max(0, numNeighbors - currentPage + 1));
        return [
            ...Array(rightBoundary - leftBoundary + 1).keys()
        ].map((i)=>i + leftBoundary);
    };
    return [
        {
            incrementPage: incrementPage,
            decrementPage: decrementPage,
            goToPage: goToPage,
            minPageReached: minPageReached,
            maxPageReached: maxPageReached,
            getPageRange: getPageRange
        }
    ];
};
var $0ef3fc8611d56815$export$2e2bcd8739ae039 = $0ef3fc8611d56815$var$usePagination;




const $1edefcf4055fc9a6$var$SvgCircleLeft = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm-.124 16.697.52-.527a.572.572 0 0 0-.009-.815L9.56 12.626h6.742a.565.565 0 0 0 .563-.57v-.76a.565.565 0 0 0-.563-.57H9.56l2.827-2.73a.576.576 0 0 0 .01-.814l-.521-.528a.556.556 0 0 0-.796 0l-4.56 4.62a.573.573 0 0 0 0 .806l4.56 4.617a.556.556 0 0 0 .796 0Z"
        })
    });
var $1edefcf4055fc9a6$export$2e2bcd8739ae039 = $1edefcf4055fc9a6$var$SvgCircleLeft;



const $831351fb15d68ad0$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "compact__Wrapper",
    componentId: "sc-1a5y08h-0"
})([
    "",
    " display:flex;align-items:center;justify-content:end;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $831351fb15d68ad0$var$StyledSVG = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "compact__StyledSVG",
    componentId: "sc-1a5y08h-1"
})([
    ""
]);
const $831351fb15d68ad0$var$ArrowButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "compact__ArrowButton",
    componentId: "sc-1a5y08h-2"
})([
    "",
    " height:24px;width:24px;background:none;padding:0;border-radius:50%;& ",
    "{",
    " height:24px;width:24px;fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), $831351fb15d68ad0$var$StyledSVG, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $831351fb15d68ad0$var$StyledSVG, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $831351fb15d68ad0$var$StyledLabel = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "compact__StyledLabel",
    componentId: "sc-1a5y08h-3"
})([
    "",
    " color:",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), (props)=>props.theme.klerosUIComponentsPrimaryText);
const $831351fb15d68ad0$var$LeftArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__LeftArrow",
    componentId: "sc-1a5y08h-4"
})([
    "margin-left:16px;"
]);
const $831351fb15d68ad0$var$RightArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__RightArrow",
    componentId: "sc-1a5y08h-5"
})([
    "margin-left:8px;& ",
    "{transform:rotate(180deg);}"
], $831351fb15d68ad0$var$StyledSVG);
const $831351fb15d68ad0$var$CompactPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, label: label, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, minPageReached: minPageReached, maxPageReached: maxPageReached }] = (0, $0ef3fc8611d56815$export$2e2bcd8739ae039)(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($831351fb15d68ad0$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($831351fb15d68ad0$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($831351fb15d68ad0$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1edefcf4055fc9a6$export$2e2bcd8739ae039), {
                    className: $831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($831351fb15d68ad0$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $1edefcf4055fc9a6$export$2e2bcd8739ae039), {
                    className: $831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            })
        ]
    });
};
var $831351fb15d68ad0$export$2e2bcd8739ae039 = $831351fb15d68ad0$var$CompactPagination;








const $60c375d8d52bb6d6$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "standard__Wrapper",
    componentId: "sc-n01q9o-0"
})([
    "",
    " display:flex;align-items:center;justify-content:center;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $60c375d8d52bb6d6$var$PageButton = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "standard__PageButton",
    componentId: "sc-n01q9o-1"
})([
    "",
    " height:32px;width:32px;margin:4px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:center;font-size:14px;color:",
    ";:hover:enabled{background:",
    ";border:1px solid ",
    ";color:",
    ";}:hover:disabled{cursor:default;}"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), (props)=>props.selected ? props.theme.klerosUIComponentsLightBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsPrimaryText, (props)=>props.selected ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsLightBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue);
const $60c375d8d52bb6d6$var$StyledArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "standard__StyledArrow",
    componentId: "sc-n01q9o-2"
})([
    ""
]);
const $60c375d8d52bb6d6$var$ArrowButton = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($60c375d8d52bb6d6$var$PageButton).withConfig({
    displayName: "standard__ArrowButton",
    componentId: "sc-n01q9o-3"
})([
    "& ",
    "{",
    " fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $60c375d8d52bb6d6$var$StyledArrow, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryText, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $60c375d8d52bb6d6$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $60c375d8d52bb6d6$var$LeftArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__LeftArrow",
    componentId: "sc-n01q9o-4"
})([
    "& ",
    "{padding-right:1px;}"
], $60c375d8d52bb6d6$var$StyledArrow);
const $60c375d8d52bb6d6$var$RightArrow = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__RightArrow",
    componentId: "sc-n01q9o-5"
})([
    "& ",
    "{padding-left:1px;transform:rotate(180deg);}"
], $60c375d8d52bb6d6$var$StyledArrow);
const $60c375d8d52bb6d6$var$StandardPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, disableNumbers: disableNumbers, hideNumbers: hideNumbers, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, goToPage: goToPage, minPageReached: minPageReached, maxPageReached: maxPageReached, getPageRange: getPageRange }] = (0, $0ef3fc8611d56815$export$2e2bcd8739ae039)(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($60c375d8d52bb6d6$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($60c375d8d52bb6d6$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $be261e7e6de1aa96$export$2e2bcd8739ae039), {
                    className: $60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            }),
            !hideNumbers && getPageRange().map((i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($60c375d8d52bb6d6$var$PageButton, {
                    selected: currentPage === i,
                    onClick: ()=>goToPage(i),
                    disabled: disableNumbers,
                    children: i
                }, i)),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($60c375d8d52bb6d6$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $be261e7e6de1aa96$export$2e2bcd8739ae039), {
                    className: $60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            })
        ]
    });
};
var $60c375d8d52bb6d6$export$2e2bcd8739ae039 = $60c375d8d52bb6d6$var$StandardPagination;






const $35a1a5ac66949050$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "tabs__Wrapper",
    componentId: "sc-1dgmogo-0"
})([
    "",
    " height:fit-content;width:500px;display:flex;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $35a1a5ac66949050$var$StyledSVG = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "tabs__StyledSVG",
    componentId: "sc-1dgmogo-1"
})([
    ""
]);
const $35a1a5ac66949050$var$StyledTab = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "tabs__StyledTab",
    componentId: "sc-1dgmogo-2"
})([
    "",
    " flex-grow:1;height:45px;background:none;border-bottom:3px solid ",
    ";display:flex;align-items:center;justify-content:center;color:",
    ";",
    " & ",
    "{",
    " height:16px;width:16px;margin-right:16px;fill:",
    ";}"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
}, (props)=>!props.disabled && !props.selected ? `:hover {
            border-bottom: 3px solid
              ${props.theme.klerosUIComponentsSecondaryBlue};
          }` : "", $35a1a5ac66949050$var$StyledSVG, (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
});
const $35a1a5ac66949050$var$Tabs = ({ items: items, ...props })=>{
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($35a1a5ac66949050$var$Wrapper, {
        ...props,
        children: items.map(({ Icon: Icon, icon: icon, text: text, value: value, disabled: disabled })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($35a1a5ac66949050$var$StyledTab, {
                disabled: disabled,
                selected: value === props.currentValue,
                onClick: ()=>props.callback(value),
                children: [
                    icon ?? (Icon && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(Icon, {
                        className: $35a1a5ac66949050$var$StyledSVG.styledComponentId
                    })),
                    text
                ]
            }, value))
    });
};
var $35a1a5ac66949050$export$2e2bcd8739ae039 = $35a1a5ac66949050$var$Tabs;






const $a6857e6cae2f9c5f$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "breadcrumb__Wrapper",
    componentId: "sc-2m5bd-0"
})([
    "",
    " display:flex;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $a6857e6cae2f9c5f$var$Element = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "breadcrumb__Element",
    componentId: "sc-2m5bd-1"
})([
    "",
    " background:none;padding:0;:hover{",
    "}"
], (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), ({ clickable: clickable, theme: theme })=>clickable ? `small { color: ${theme.klerosUIComponentsPrimaryText}; }` : `cursor: text !important`);
const $a6857e6cae2f9c5f$var$Content = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "breadcrumb__Content",
    componentId: "sc-2m5bd-2"
})([
    "",
    " transition:color ease ",
    ";"
], (0, $49a276e58256b44f$export$3c17b0e969a90510), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $a6857e6cae2f9c5f$var$Separator = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__Separator",
    componentId: "sc-2m5bd-3"
})([
    "margin:0px 8px;"
]);
const $a6857e6cae2f9c5f$var$ActiveElement = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__ActiveElement",
    componentId: "sc-2m5bd-4"
})([
    "color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $a6857e6cae2f9c5f$var$Breadcrumb = ({ items: items, callback: callback, clickable: clickable, className: className })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a6857e6cae2f9c5f$var$Wrapper, {
        className: className,
        children: items.map(({ text: text, value: value }, i)=>i === items.length - 1 ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a6857e6cae2f9c5f$var$ActiveElement, {
                children: text
            }, i) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)((0, ($parcel$interopDefault($jXom6$react))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a6857e6cae2f9c5f$var$Element, {
                        onClick: ()=>callback ? callback(value) : null,
                        clickable: clickable,
                        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a6857e6cae2f9c5f$var$Content, {
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a6857e6cae2f9c5f$var$Separator, {
                        children: "/"
                    })
                ]
            }, i))
    });
var $a6857e6cae2f9c5f$export$2e2bcd8739ae039 = $a6857e6cae2f9c5f$var$Breadcrumb;







const $d623bf354733f290$var$SvgHourglass = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        width: 12,
        height: 15,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M1.275 14.5h9.31a.66.66 0 0 0 .665-.656v-.438a.66.66 0 0 0-.665-.656c0-2.487-1.414-4.586-3.348-5.25 1.934-.664 3.348-2.763 3.348-5.25a.66.66 0 0 0 .665-.656v-.438A.66.66 0 0 0 10.585.5h-9.31a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656c0 2.487 1.414 4.586 3.348 5.25-1.934.664-3.348 2.763-3.348 5.25a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656ZM3.048 2.25h5.764c0 2.118-1.28 3.938-2.882 3.938-1.601 0-2.882-1.82-2.882-3.938Z"
        })
    });
var $d623bf354733f290$export$2e2bcd8739ae039 = $d623bf354733f290$var$SvgHourglass;



const $8688d42e9f1d381a$var$progressAnimation = (width)=>(0, $jXom6$styledcomponents.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], width);
const $8688d42e9f1d381a$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "linear__Wrapper",
    componentId: "sc-bwbdj5-0"
})([
    "",
    " display:flex;flex-direction:column;align-items:center;font-size:14px;color:",
    ";"
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $8688d42e9f1d381a$var$StyledText = (0, ($parcel$interopDefault($jXom6$styledcomponents))).p.withConfig({
    displayName: "linear__StyledText",
    componentId: "sc-bwbdj5-1"
})([
    "",
    ""
], (0, $49a276e58256b44f$export$ffb5f4729a158638));
const $8688d42e9f1d381a$var$BarTimerWrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "linear__BarTimerWrapper",
    componentId: "sc-bwbdj5-2"
})([
    "display:flex;flex-direction:column;align-items:flex-start;"
]);
const $8688d42e9f1d381a$var$LinearChart = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "linear__LinearChart",
    componentId: "sc-bwbdj5-3"
})([
    "",
    " stroke:",
    ";display:block;margin:10px auto;"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ width: width })=>width);
const $8688d42e9f1d381a$var$LineBackground = (0, ($parcel$interopDefault($jXom6$styledcomponents))).path.withConfig({
    displayName: "linear__LineBackground",
    componentId: "sc-bwbdj5-4"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $8688d42e9f1d381a$var$Line = (0, ($parcel$interopDefault($jXom6$styledcomponents))).path.withConfig({
    displayName: "linear__Line",
    componentId: "sc-bwbdj5-5"
})([
    "stroke:",
    ";",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsSuccess, ({ animated: animated, width: width })=>animated && (0, $jXom6$styledcomponents.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $8688d42e9f1d381a$var$progressAnimation(width)));
const $8688d42e9f1d381a$var$StyledHourglass = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $d623bf354733f290$export$2e2bcd8739ae039)).withConfig({
    displayName: "linear__StyledHourglass",
    componentId: "sc-bwbdj5-6"
})([
    "",
    " margin-right:9.75px;fill:",
    ";"
], (0, $49a276e58256b44f$export$7ed1367e7fa1ad68), ({ theme: theme })=>theme.klerosUIComponentsError);
const $8688d42e9f1d381a$var$TimerMessage = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "linear__TimerMessage",
    componentId: "sc-bwbdj5-7"
})([
    "margin-top:5px;display:flex;justify-content:center;align-items:center;color:",
    ";font-weight:600;line-height:1em;"
], ({ theme: theme })=>theme.klerosUIComponentsError);
const $8688d42e9f1d381a$var$Linear = ({ text: text, progress: progress, width: width, timerText: timerText, animated: animated = true })=>{
    const sw = 8;
    const linePath = `M ${sw / 2} ${sw / 2} h ${width - sw}`;
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($8688d42e9f1d381a$var$Wrapper, {
        children: [
            text && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($8688d42e9f1d381a$var$StyledText, {
                children: text
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($8688d42e9f1d381a$var$BarTimerWrapper, {
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($8688d42e9f1d381a$var$LinearChart, {
                        width: width,
                        height: sw,
                        fill: "none",
                        strokeWidth: sw,
                        strokeLinecap: "round",
                        children: [
                            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($8688d42e9f1d381a$var$LineBackground, {
                                d: linePath
                            }),
                            progress && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($8688d42e9f1d381a$var$Line, {
                                animated: animated,
                                width: width,
                                strokeDasharray: `${progress * width / 100} ${width}`,
                                d: linePath
                            })
                        ]
                    }),
                    timerText && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($8688d42e9f1d381a$var$TimerMessage, {
                        children: [
                            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($8688d42e9f1d381a$var$StyledHourglass, {}),
                            timerText
                        ]
                    })
                ]
            })
        ]
    });
};
var $8688d42e9f1d381a$export$2e2bcd8739ae039 = $8688d42e9f1d381a$var$Linear;






const $e09296aea30ed10d$var$progressAnimation = (circ)=>(0, $jXom6$styledcomponents.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], circ);
const $e09296aea30ed10d$var$CircularChart = (0, ($parcel$interopDefault($jXom6$styledcomponents))).svg.withConfig({
    displayName: "circular__CircularChart",
    componentId: "sc-73w0na-0"
})([
    "",
    " ",
    " display:block;margin:10px auto;"
], (0, $49a276e58256b44f$export$ed32643c9618a26), (0, $49a276e58256b44f$export$7ed1367e7fa1ad68));
const $e09296aea30ed10d$var$CircleBackground = (0, ($parcel$interopDefault($jXom6$styledcomponents))).path.withConfig({
    displayName: "circular__CircleBackground",
    componentId: "sc-73w0na-1"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $e09296aea30ed10d$var$Circle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).path.withConfig({
    displayName: "circular__Circle",
    componentId: "sc-73w0na-2"
})([
    "stroke:",
    ";",
    ""
], (props)=>props.progress < 100 ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSuccess, ({ animated: animated, circ: circ })=>animated && (0, $jXom6$styledcomponents.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $e09296aea30ed10d$var$progressAnimation(circ)));
const $e09296aea30ed10d$var$Percentage = (0, ($parcel$interopDefault($jXom6$styledcomponents))).text.withConfig({
    displayName: "circular__Percentage",
    componentId: "sc-73w0na-3"
})([
    "fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $e09296aea30ed10d$var$Circular = ({ progress: progress, small: small, animated: animated = true })=>{
    const width = small ? 80 : 120;
    const sw = width / 20; // stroke-width
    const rad = (width - sw) / 2 + 1;
    const dy = width - sw + 2;
    const circ = 2 * Math.PI * rad;
    const circlePath = `M ${(width + sw) / 2} ${sw / 2}
  a ${rad} ${rad} 0 0 1 0 ${dy}
  a ${rad} ${rad} 0 0 1 0 -${dy}`;
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($e09296aea30ed10d$var$CircularChart, {
        fill: "none",
        strokeWidth: sw,
        strokeLinecap: "round",
        width: width + sw,
        height: width + sw,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($e09296aea30ed10d$var$CircleBackground, {
                d: circlePath
            }),
            progress && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($e09296aea30ed10d$var$Circle, {
                strokeDasharray: `${circ * progress / 100} ${circ}`,
                progress: progress,
                d: circlePath,
                circ: circ,
                animated: animated
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($e09296aea30ed10d$var$Percentage, {
                fontSize: small ? 16 : 24,
                fontWeight: 600,
                textAnchor: "middle",
                dominantBaseline: "middle",
                x: "50%",
                y: "50%",
                children: [
                    progress,
                    "%"
                ]
            })
        ]
    });
};
var $e09296aea30ed10d$export$2e2bcd8739ae039 = $e09296aea30ed10d$var$Circular;














const $757595619553281c$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet-circle__Wrapper",
    componentId: "sc-1bvj53u-0"
})([
    "height:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $757595619553281c$var$StyledSuccess = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $1fbc1df023618cf8$export$2e2bcd8739ae039)).withConfig({
    displayName: "bullet-circle__StyledSuccess",
    componentId: "sc-1bvj53u-1"
})([
    "height:24px;width:24px;flex-basis:auto;fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $757595619553281c$var$Circle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet-circle__Circle",
    componentId: "sc-1bvj53u-2"
})([
    "height:24px;width:24px;flex-basis:auto;background-color:",
    ";border-radius:12px;border:1px solid ",
    ";display:flex;justify-content:center;align-items:center;font-size:12px;color:",
    ";"
], (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.active ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsStroke);
const $757595619553281c$var$Line = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet-circle__Line",
    componentId: "sc-1bvj53u-3"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";margin:8px 0px;"
], (props)=>props.completed ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke);
const $757595619553281c$var$BulletCircle = ({ active: active, completed: completed, line: line, index: index, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($757595619553281c$var$Wrapper, {
        ...props,
        children: [
            completed ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($757595619553281c$var$StyledSuccess, {}) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($757595619553281c$var$Circle, {
                active: active,
                children: [
                    " ",
                    index,
                    " "
                ]
            }),
            line && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($757595619553281c$var$Line, {
                completed: completed
            })
        ]
    });
var $757595619553281c$export$2e2bcd8739ae039 = $757595619553281c$var$BulletCircle;



const $c37ea337805e62b1$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-1ly7f40-0"
})([
    "flex-basis:0;flex-grow:1;width:fit-content;display:flex;"
]);
const $c37ea337805e62b1$var$StyledTitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-1ly7f40-1"
})([
    ""
]);
const $c37ea337805e62b1$var$StyledBody = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "bullet__StyledBody",
    componentId: "sc-1ly7f40-2"
})([
    ""
]);
const $c37ea337805e62b1$var$TextContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-1ly7f40-3"
})([
    "margin-left:16px;margin-top:2px;& ",
    "{",
    " font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " font-size:12px;line-height:16px;}"
], $c37ea337805e62b1$var$StyledTitle, (0, $49a276e58256b44f$export$a943aa9a0fca3f0b), (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $c37ea337805e62b1$var$StyledBody, (0, $49a276e58256b44f$export$3c17b0e969a90510));
const $c37ea337805e62b1$var$SubitemsContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet__SubitemsContainer",
    componentId: "sc-1ly7f40-4"
})([
    "display:flex;flex-direction:column;"
]);
const $c37ea337805e62b1$var$Bullet = ({ title: title, subitems: subitems, index: index, active: active, completed: completed, line: line, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($c37ea337805e62b1$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $757595619553281c$export$2e2bcd8739ae039), {
                index: index,
                active: active,
                completed: completed,
                line: line
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($c37ea337805e62b1$var$TextContainer, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($c37ea337805e62b1$var$StyledTitle, {
                        children: title
                    }),
                    subitems && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($c37ea337805e62b1$var$SubitemsContainer, {
                        children: subitems.map((item, i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($c37ea337805e62b1$var$StyledBody, {
                                children: item
                            }, i))
                    })
                ]
            })
        ]
    });
var $c37ea337805e62b1$export$2e2bcd8739ae039 = $c37ea337805e62b1$var$Bullet;


const $2f7d25ee5647072f$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "vertical__Wrapper",
    componentId: "sc-1rvtpa4-0"
})([
    "height:100px;display:flex;flex-direction:column;"
]);
const $2f7d25ee5647072f$var$BulletsContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "vertical__BulletsContainer",
    componentId: "sc-1rvtpa4-1"
})([
    "height:auto;display:flex;flex-direction:column;flex-grow:1;"
]);
const $2f7d25ee5647072f$var$LastBullet = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $c37ea337805e62b1$export$2e2bcd8739ae039)).withConfig({
    displayName: "vertical__LastBullet",
    componentId: "sc-1rvtpa4-2"
})([
    "flex-basis:auto;flex-grow:0;"
]);
const $2f7d25ee5647072f$var$Steps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($2f7d25ee5647072f$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2f7d25ee5647072f$var$BulletsContainer, {
                children: items.slice(0, -1).map(({ title: title, subitems: subitems }, i)=>/*#__PURE__*/ (0, $jXom6$react.createElement)((0, $c37ea337805e62b1$export$2e2bcd8739ae039), {
                        title: title,
                        subitems: subitems,
                        completed: i < currentItemIndex,
                        active: i === currentItemIndex,
                        line: !(i + 1 === items.length),
                        index: i + 1,
                        key: i
                    }))
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($2f7d25ee5647072f$var$LastBullet, {
                title: lastItem.title,
                subitems: lastItem.subitems,
                completed: items.length - 1 < currentItemIndex,
                active: items.length - 1 === currentItemIndex,
                index: items.length
            })
        ]
    });
};
var $2f7d25ee5647072f$export$2e2bcd8739ae039 = $2f7d25ee5647072f$var$Steps;










const $cf0f856d949d5193$var$Container = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "horizontal-bullet__Container",
    componentId: "sc-1tljr4r-0"
})([
    "position:relative;height:fit-content;display:flex;justify-content:center;align-items:start;",
    ""
], ({ theme: theme, last: last, completed: completed })=>last ? (0, $jXom6$styledcomponents.css)([
        "flex-grow:0;"
    ]) : (0, $jXom6$styledcomponents.css)([
        'flex-grow:1;:after{content:"";height:0px;width:auto;flex-grow:1;border-top:1px solid ',
        ";margin:12px 16px;}"
    ], completed ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke));
const $cf0f856d949d5193$var$TextWrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "horizontal-bullet__TextWrapper",
    componentId: "sc-1tljr4r-1"
})([
    "margin-left:8px;display:flex;flex-direction:column;align-items:start;> h2{",
    " font-size:14px;line-height:24px;color:",
    ";}> small{",
    " font-size:12px;line-height:16px;}",
    ""
], (0, $49a276e58256b44f$export$a943aa9a0fca3f0b), (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, (0, $49a276e58256b44f$export$3c17b0e969a90510), (0, $49a276e58256b44f$export$44eafa1b177a8b30)(()=>(0, $jXom6$styledcomponents.css)([
        "position:absolute;top:24px;left:0;margin-left:0px;transform:translateX(calc(-50% + 12px));align-items:center;text-align:center;> h2{line-height:19px;}"
    ])));
const $cf0f856d949d5193$var$HorizontalBullet = ({ index: index, title: title, subitems: subitems, active: active, last: last, completed: completed, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($cf0f856d949d5193$var$Container, {
        active: active,
        completed: completed,
        last: last,
        ...props,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $757595619553281c$export$2e2bcd8739ae039), {
                active: active,
                completed: completed,
                index: index
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($cf0f856d949d5193$var$TextWrapper, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("h2", {
                        children: title
                    }),
                    subitems && subitems.map((item, i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("small", {
                            children: item
                        }, i))
                ]
            })
        ]
    });
var $cf0f856d949d5193$export$2e2bcd8739ae039 = $cf0f856d949d5193$var$HorizontalBullet;



const $4987b48a13ec5480$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "horizontal__Wrapper",
    componentId: "sc-12u32gl-0"
})([
    "",
    " width:250px;display:flex;justify-content:center;align-items:start;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $4987b48a13ec5480$var$HorizontalSteps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($4987b48a13ec5480$var$Wrapper, {
        ...props,
        children: items.map((item, i)=>/*#__PURE__*/ (0, $jXom6$react.createElement)((0, $cf0f856d949d5193$export$2e2bcd8739ae039), {
                ...item,
                completed: i < currentItemIndex,
                active: i === currentItemIndex,
                last: i + 1 === items.length,
                index: i + 1,
                key: i
            }))
    });
var $4987b48a13ec5480$export$2e2bcd8739ae039 = $4987b48a13ec5480$var$HorizontalSteps;


const $250cfcb8116ed97e$var$Steps = ({ horizontal: horizontal, ...props })=>horizontal ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $4987b48a13ec5480$export$2e2bcd8739ae039), {
        ...props
    }) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $2f7d25ee5647072f$export$2e2bcd8739ae039), {
        ...props
    });
var $250cfcb8116ed97e$export$2e2bcd8739ae039 = $250cfcb8116ed97e$var$Steps;











const $b17bb74d528cffb5$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "spine__Wrapper",
    componentId: "sc-1nqkm41-0"
})([
    "height:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $b17bb74d528cffb5$var$colorRegex = new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$");
const $b17bb74d528cffb5$export$ce7158e6888ab5d6 = (0, $jXom6$styledcomponents.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "accepted") return theme.klerosUIComponentsSuccess;
    if (variant === "refused") return theme.klerosUIComponentsError;
    if (variant && $b17bb74d528cffb5$var$colorRegex.test(variant)) return variant;
    return theme.klerosUIComponentsPrimaryBlue;
});
const $b17bb74d528cffb5$var$Circle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "spine__Circle",
    componentId: "sc-1nqkm41-1"
})([
    "height:16px;width:16px;flex-basis:auto;background-color:",
    ";border-radius:8px;border:2px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $b17bb74d528cffb5$export$ce7158e6888ab5d6);
const $b17bb74d528cffb5$var$Line = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "spine__Line",
    componentId: "sc-1nqkm41-2"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $b17bb74d528cffb5$var$Spine = ({ variant: variant, line: line, Icon: Icon })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($b17bb74d528cffb5$var$Wrapper, {
        children: [
            Icon ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)(Icon, {}) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b17bb74d528cffb5$var$Circle, {
                variant: variant
            }),
            line && /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($b17bb74d528cffb5$var$Line, {})
        ]
    });
var $b17bb74d528cffb5$export$2e2bcd8739ae039 = $b17bb74d528cffb5$var$Spine;



const $febc15bff886858c$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-6vrqo5-0"
})([
    "display:flex;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $febc15bff886858c$var$StyledTitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-6vrqo5-1"
})([
    ""
]);
const $febc15bff886858c$var$StyledParty = (0, ($parcel$interopDefault($jXom6$styledcomponents))).p.withConfig({
    displayName: "bullet__StyledParty",
    componentId: "sc-6vrqo5-2"
})([
    ""
]);
const $febc15bff886858c$var$StyledSubtitle = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "bullet__StyledSubtitle",
    componentId: "sc-6vrqo5-3"
})([
    ""
]);
const $febc15bff886858c$var$TextContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-6vrqo5-4"
})([
    "margin-",
    ":20px;order:",
    ";display:flex;flex-direction:column;margin-bottom:",
    ";gap:2px;text-align:",
    ";@media (max-width:900px){margin-",
    ":16px;margin-bottom:",
    ";gap:4px;}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " align-self:flex-",
    ";font-size:12px;line-height:16px;}"
], ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? 1 : -1, ({ isLast: isLast })=>isLast ? "0" : "18px", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ isLast: isLast })=>isLast ? "0" : "16px", $febc15bff886858c$var$StyledTitle, (0, $49a276e58256b44f$export$a943aa9a0fca3f0b), ({ rightSided: rightSided })=>rightSided ? 1 : 2, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, $febc15bff886858c$var$StyledParty, (0, $49a276e58256b44f$export$ffb5f4729a158638), ({ rightSided: rightSided })=>rightSided ? 2 : 1, (0, $b17bb74d528cffb5$export$ce7158e6888ab5d6), $febc15bff886858c$var$StyledSubtitle, (0, $49a276e58256b44f$export$3c17b0e969a90510), ({ rightSided: rightSided })=>rightSided ? "start" : "end");
const $febc15bff886858c$var$PartyTitleContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "bullet__PartyTitleContainer",
    componentId: "sc-6vrqo5-5"
})([
    "display:flex;flex-direction:row;flex-wrap:wrap;gap:4px 8px;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $febc15bff886858c$var$Bullet = (props)=>{
    const { title: title, party: party, subtitle: subtitle, ...restProps } = props;
    const { rightSided: rightSided, variant: variant, line: line, Icon: Icon, isLast: isLast, ...wrapperProps } = restProps;
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($febc15bff886858c$var$Wrapper, {
        rightSided: rightSided,
        ...wrapperProps,
        children: [
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $b17bb74d528cffb5$export$2e2bcd8739ae039), {
                variant: variant,
                line: line,
                Icon: Icon
            }),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($febc15bff886858c$var$TextContainer, {
                variant: variant,
                rightSided: rightSided,
                isLast: isLast,
                children: [
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($febc15bff886858c$var$PartyTitleContainer, {
                        rightSided: rightSided,
                        children: [
                            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($febc15bff886858c$var$StyledTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($febc15bff886858c$var$StyledParty, {
                                children: party
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($febc15bff886858c$var$StyledSubtitle, {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $febc15bff886858c$export$2e2bcd8739ae039 = $febc15bff886858c$var$Bullet;



const $c3e303edb7751c77$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "timeline__Wrapper",
    componentId: "sc-rxkvqs-0"
})([
    "",
    " display:flex;flex-direction:column;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $c3e303edb7751c77$var$StyledBullet = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $febc15bff886858c$export$2e2bcd8739ae039)).withConfig({
    displayName: "timeline__StyledBullet",
    componentId: "sc-rxkvqs-1"
})([
    "position:relative;transform:translateX( ",
    " );"
], ({ rightSided: rightSided })=>rightSided ? "calc(50% - 8px)" : "calc(-50% + 8px)");
const $c3e303edb7751c77$var$LastBullet = (0, ($parcel$interopDefault($jXom6$styledcomponents)))($c3e303edb7751c77$var$StyledBullet).withConfig({
    displayName: "timeline__LastBullet",
    componentId: "sc-rxkvqs-2"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $c3e303edb7751c77$var$Timeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($c3e303edb7751c77$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($c3e303edb7751c77$var$StyledBullet, {
                    line: true,
                    ...item,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($c3e303edb7751c77$var$LastBullet, {
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $c3e303edb7751c77$export$2e2bcd8739ae039 = $c3e303edb7751c77$var$Timeline;







const $a3f868921843a442$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-k2o2ay-0"
})([
    "",
    " display:flex;flex-direction:column;"
], (0, $49a276e58256b44f$export$ed32643c9618a26));
const $a3f868921843a442$var$LastBullet = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $febc15bff886858c$export$2e2bcd8739ae039)).withConfig({
    displayName: "custom__LastBullet",
    componentId: "sc-k2o2ay-1"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $a3f868921843a442$var$CustomTimeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($a3f868921843a442$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $febc15bff886858c$export$2e2bcd8739ae039), {
                    line: true,
                    ...item,
                    rightSided: true,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($a3f868921843a442$var$LastBullet, {
                rightSided: true,
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $a3f868921843a442$export$2e2bcd8739ae039 = $a3f868921843a442$var$CustomTimeline;






const $4c05722f1abfb34c$var$BaseTag = (0, ($parcel$interopDefault($jXom6$styledcomponents))).button.withConfig({
    displayName: "tag__BaseTag",
    componentId: "sc-19f0jzg-0"
})([
    "",
    " ",
    " height:32px;background:",
    ";border:",
    ";border-radius:300px;padding:0 16px;display:flex;justify-content:center;align-items:center;"
], (0, $49a276e58256b44f$export$ed32643c9618a26), (0, $49a276e58256b44f$export$2ba01fb71ed41cb6), ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme, active: active })=>active ? `1px solid ${theme.klerosUIComponentsPrimaryBlue}` : "none");
const $4c05722f1abfb34c$var$StyledText = (0, ($parcel$interopDefault($jXom6$styledcomponents))).p.withConfig({
    displayName: "tag__StyledText",
    componentId: "sc-19f0jzg-1"
})([
    "",
    " color:",
    ";"
], (0, $49a276e58256b44f$export$ffb5f4729a158638), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $4c05722f1abfb34c$var$Tag = ({ text: text, active: active, as: as, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($4c05722f1abfb34c$var$BaseTag, {
        active: active,
        as: as,
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($4c05722f1abfb34c$var$StyledText, {
            children: text
        })
    });
var $4c05722f1abfb34c$export$2e2bcd8739ae039 = $4c05722f1abfb34c$var$Tag;






const $4ceeceac8d19d80b$var$StyledText = (0, ($parcel$interopDefault($jXom6$styledcomponents))).small.withConfig({
    displayName: "tooltip__StyledText",
    componentId: "sc-2flh2z-0"
})([
    ""
]);
const $4ceeceac8d19d80b$var$StyledTooltip = (0, ($parcel$interopDefault($jXom6$styledcomponents))).span.withConfig({
    displayName: "tooltip__StyledTooltip",
    componentId: "sc-2flh2z-1"
})([
    "",
    " ",
    ""
], (0, $49a276e58256b44f$export$ed32643c9618a26), ({ place: place, theme: theme, small: small })=>(0, $jXom6$styledcomponents.css)([
        "visibility:hidden;position:absolute;z-index:1;width:max-content;max-width:240px;background:",
        ";border-radius:3px;padding:13px 16px;display:flex;justify-content:center;align-items:center;& ",
        "{",
        " font-weight:100;text-align:",
        ";color:",
        ';}::after{content:"";position:absolute;border-width:8px;border-style:solid;}',
        " ",
        " ",
        " ",
        ""
    ], theme.klerosUIComponentsPrimaryBlue, $4ceeceac8d19d80b$var$StyledText, (0, $49a276e58256b44f$export$3c17b0e969a90510), small ? "center" : "left", theme.klerosUIComponentsWhiteBackground, place === "top" && (0, $jXom6$styledcomponents.css)([
        "bottom:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{top:100%;left:50%;transform:translateX(-50%);border-color:",
        " transparent transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "right" && (0, $jXom6$styledcomponents.css)([
        "top:50%;left:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;right:100%;transform:translateY(-50%);border-color:transparent ",
        " transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "bottom" && (0, $jXom6$styledcomponents.css)([
        "top:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{left:50%;bottom:100%;transform:translateX(-50%);border-color:transparent transparent ",
        " transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "left" && (0, $jXom6$styledcomponents.css)([
        "top:50%;right:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;left:100%;transform:translateY(-50%);border-color:transparent transparent transparent ",
        ";}"
    ], theme.klerosUIComponentsPrimaryBlue)));
const $4ceeceac8d19d80b$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "tooltip__Wrapper",
    componentId: "sc-2flh2z-2"
})([
    "position:relative;display:inline-block;&:hover ",
    "{visibility:visible;}"
], $4ceeceac8d19d80b$var$StyledTooltip);
const $4ceeceac8d19d80b$var$Tooltip = ({ place: place = "top", text: text, children: children, small: small, ...props })=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($4ceeceac8d19d80b$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($4ceeceac8d19d80b$var$StyledTooltip, {
                small: small,
                place: place,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($4ceeceac8d19d80b$var$StyledText, {
                    children: text
                })
            })
        ]
    });
var $4ceeceac8d19d80b$export$2e2bcd8739ae039 = $4ceeceac8d19d80b$var$Tooltip;









const $a5329119b99a1727$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 16",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
            d: "M13.776 2.06 12.129.44A1.536 1.536 0 0 0 11.05 0H5.587c-.841 0-1.524.672-1.524 1.5V3h-2.54C.684 3 0 3.672 0 4.5v10c0 .828.682 1.5 1.524 1.5h7.11c.843 0 1.525-.672 1.525-1.5V13h2.54c.841 0 1.523-.672 1.523-1.5V3.121c0-.398-.16-.779-.446-1.06ZM8.444 14.5h-6.73a.192.192 0 0 1-.134-.055.186.186 0 0 1-.056-.133V4.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .134-.055h2.35v7c0 .828.682 1.5 1.523 1.5h3.048v1.313c0 .05-.02.097-.056.132a.192.192 0 0 1-.135.055Zm4.064-3h-6.73a.192.192 0 0 1-.135-.055.186.186 0 0 1-.056-.133V1.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .135-.055h3.365v2.75c0 .414.341.75.762.75h2.793v6.313c0 .05-.02.097-.055.132a.192.192 0 0 1-.135.055Zm.19-8h-2.031v-2h.305c.051 0 .1.02.135.055l1.536 1.511a.186.186 0 0 1 .055.133V3.5Z",
            fill: "#009AFF"
        })
    });
var $a5329119b99a1727$export$2e2bcd8739ae039 = $a5329119b99a1727$var$SvgCopy;




const $24ee0e3ed5abf092$var$SvgCopied = (props)=>/*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("g", {
            clipPath: "url('#clip0_13289_179292')",
            children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 8.5a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8.5Zm1.357 0a6.644 6.644 0 0 0 13.286 0 6.644 6.644 0 0 0-13.286 0Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 11.1a.567.567 0 0 1-.923 0L4.545 8.016a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z",
                fill: "#009AFF"
            })
        })
    });
var $24ee0e3ed5abf092$export$2e2bcd8739ae039 = $24ee0e3ed5abf092$var$SvgCopied;


const $f9cf7fe05b87a0bc$var$Wrapper = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "copiable__Wrapper",
    componentId: "sc-3t2xjv-0"
})([
    "position:relative;display:inline-flex;align-items:center;gap:8px;"
]);
const $f9cf7fe05b87a0bc$var$StyledTooltip = (0, ($parcel$interopDefault($jXom6$styledcomponents)))((0, $4ceeceac8d19d80b$export$2e2bcd8739ae039)).withConfig({
    displayName: "copiable__StyledTooltip",
    componentId: "sc-3t2xjv-1"
})([
    "> span{padding:8px;}"
]);
const $f9cf7fe05b87a0bc$var$IconContainer = (0, ($parcel$interopDefault($jXom6$styledcomponents))).div.withConfig({
    displayName: "copiable__IconContainer",
    componentId: "sc-3t2xjv-2"
})([
    "cursor:pointer;display:flex;align-items:center;width:16px;height:16px;"
]);
/**
 * @description Wraps a component to make it copiable.
 * @param copiableContent The text to be copied to user's clipboard
 * @param info Modify the message displayed in the copy button's tooltip
 * @param tooltipProps Copy button's tooltip props
 */ const $f9cf7fe05b87a0bc$var$Copiable = ({ copiableContent: copiableContent, info: info, children: children, tooltipProps: tooltipProps, ...props })=>{
    const [isCopied, setIsCopied] = (0, $jXom6$react.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(copiableContent).then(()=>{
            setIsCopied(true);
            setTimeout(()=>setIsCopied(false), 2000);
        }).catch(()=>setIsCopied(false));
    };
    return /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsxs)($f9cf7fe05b87a0bc$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($f9cf7fe05b87a0bc$var$StyledTooltip, {
                text: isCopied ? "Copied!" : `${info ?? "Copy"}`,
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)($f9cf7fe05b87a0bc$var$IconContainer, {
                    className: "icon-container",
                    children: isCopied ? /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $24ee0e3ed5abf092$export$2e2bcd8739ae039), {
                        className: "copied-icon"
                    }) : /*#__PURE__*/ (0, $jXom6$reactjsxruntime.jsx)((0, $a5329119b99a1727$export$2e2bcd8739ae039), {
                        className: "copy-icon",
                        onClick: handleCopy
                    })
                })
            })
        ]
    });
};
var $f9cf7fe05b87a0bc$export$2e2bcd8739ae039 = $f9cf7fe05b87a0bc$var$Copiable;


const $18386f08588a981e$export$f30cb9bc4f736419 = {
    klerosUIComponentsPrimaryPurple: "#4D00B4",
    klerosUIComponentsSecondaryPurple: "#9013FE",
    klerosUIComponentsMediumPurple: "#F8F1FF",
    klerosUIComponentsLightPurple: "#FBF9FE",
    klerosUIComponentsPrimaryBlue: "#009AFF",
    klerosUIComponentsSecondaryBlue: "#7BCBFF",
    klerosUIComponentsMediumBlue: "#F0F9FF",
    klerosUIComponentsLightBlue: "#FCFEFF",
    klerosUIComponentsPrimaryText: "#333333",
    klerosUIComponentsSecondaryText: "#999999",
    klerosUIComponentsStroke: "#e5e5e5",
    klerosUIComponentsLightGrey: "#FAFAFA",
    klerosUIComponentsWhiteBackground: "#FFFFFF",
    klerosUIComponentsLightBackground: "#FAFBFC",
    klerosUIComponentsDefaultShadow: "#00000002",
    klerosUIComponentsHoveredShadow: "#00000002",
    klerosUIComponentsSuccess: "#00C42B",
    klerosUIComponentsSuccessLight: "#F0FBF2",
    klerosUIComponentsWarning: "#FF9900",
    klerosUIComponentsWarningLight: "#FFF9F0",
    klerosUIComponentsError: "#F60C36",
    klerosUIComponentsErrorLight: "#FEFF0F3",
    klerosUIComponentsTint: "#D14EFF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#F4F0FA",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $18386f08588a981e$export$3e936a8db52a10a0 = {
    klerosUIComponentsPrimaryPurple: "#7E1BD4",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#6CC5FF",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#220050",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $18386f08588a981e$export$a183395ddd946500 = {
    klerosUIComponentsPrimaryPurple: "#200F47",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#69C3FC",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#200F47",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};




//# sourceMappingURL=index.js.map
